(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2349],{

/***/ 40198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _QUERIES_account_useSigninUser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5142);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30202);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21741);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32423);







var withWishList = function(WrappedComponent) {
    return function(props) {
        var ref, ref1;
        var _isActive = props.isActive, isActive = _isActive === void 0 ? false : _isActive, _evCd = props.evCd, evCd = _evCd === void 0 ? "" : _evCd, _link = props.link, link = _link === void 0 ? "" : _link, diviCd = props.diviCd, _wishNo = props.wishNo, wishNo = _wishNo === void 0 ? "" : _wishNo, addConfirm = props.addConfirm, removeConfirm = props.removeConfirm;
        var goodsCd = evCd.split("-")[0];
        var goodsTp = evCd.substring(0, 1);
        /** 로그인 */ var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQueryClient */ .NL)();
        /** 로그인 */ var signin = (0,_QUERIES_account_useSigninUser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)();
        var webCustNo = ((ref = signin.data) === null || ref === void 0 ? void 0 : ref.body.webCustNo) || "";
        var signinCode = ((ref1 = signin.data) === null || ref1 === void 0 ? void 0 : ref1.code) || "9999";
        var addWish = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                var result, _tmp, _tmp1;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = {};
                            return [
                                4,
                                (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_tmp.url = "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ENV_ESSENTIAL_API_BASEPATH */ .Z.ENV_ESSENTIAL_API_BASEPATH, "/api/customer/wishList"), _tmp.method = "POST", _tmp.data = {
                                    webCustNo: webCustNo,
                                    goodsCd: goodsCd,
                                    goodsNm: "",
                                    evCd: evCd,
                                    diviCd: diviCd,
                                    imageThum: "",
                                    link: "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ENV_PRODUCT_URL */ .Z.ENV_PRODUCT_URL).concat(link),
                                    itemCategoryCode: "".concat(goodsTp === "K" ? "D" : "P"),
                                    cityCode: "",
                                    latestAmount: ""
                                }, _tmp)).catch(function(e) {
                                    throw new Error();
                                })
                            ];
                        case 1:
                            result = _state.sent();
                            _tmp1 = {};
                            if (result.data.code === "0000") {
                                MessageUtil.alert("찜한 상품으로 등록 되었습니다.");
                                queryClient.refetchQueries((_tmp1.queryKey = [
                                    "useWishlist"
                                ], _tmp1.type = "active", _tmp1));
                            } else {
                                throw new Error();
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function addWish() {
                return _ref.apply(this, arguments);
            };
        }();
        var removeWish = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                var result, _tmp, _tmp1;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!wishNo) return [
                                2
                            ];
                            _tmp = {};
                            return [
                                4,
                                (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_tmp.url = "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ENV_ESSENTIAL_API_BASEPATH */ .Z.ENV_ESSENTIAL_API_BASEPATH, "/api/customer/wishList"), _tmp.method = "DELETE", _tmp.data = {
                                    wishList: [
                                        {
                                            productWishId: wishNo,
                                            webCustNo: webCustNo,
                                            evCd: evCd,
                                            goodsCd: goodsCd,
                                            itemCategoryCode: "P"
                                        }
                                    ]
                                }, _tmp)).catch(function(e) {
                                    throw new Error();
                                })
                            ];
                        case 1:
                            result = _state.sent();
                            _tmp1 = {};
                            if (result.data.code === "0000") {
                                MessageUtil.alert("찜한 상품이 삭제 되었습니다.");
                                queryClient.refetchQueries((_tmp1.queryKey = [
                                    "useWishlist"
                                ], _tmp1.type = "active", _tmp1));
                            } else {
                                throw new Error();
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function removeWish() {
                return _ref.apply(this, arguments);
            };
        }();
        var wish = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(e) {
                var isConfirm, isConfirm1;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!!isActive) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                MessageUtil.confirm("찜한 상품으로 등록하시겠습니까?")
                            ];
                        case 1:
                            isConfirm = _state.sent();
                            if (isConfirm) {
                                addWish();
                                typeof addConfirm === "function" && addConfirm(e);
                            }
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                MessageUtil.confirm("찜한 상품을 삭제하시겠습니까?")
                            ];
                        case 3:
                            isConfirm1 = _state.sent();
                            if (isConfirm1) {
                                removeWish();
                                typeof removeConfirm === "function" && removeConfirm(e);
                            }
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function wish(e) {
                return _ref.apply(this, arguments);
            };
        }();
        var onClick = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(e) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    try {
                        if (!evCd) throw new Error("필수 파라미터 누락");
                        if (signinCode !== "0000") {
                            MessageUtil.confirm("로그인 후 이용하실 수 있습니다. <br/>로그인하시겠습니까?", function() {
                                return LoginUtil.login();
                            });
                        } else {
                            wish(e);
                        }
                    } catch (e1) {
                        ;
                        MessageUtil.alert("오류가 발생하였습니다. <br/>".concat(e1));
                    }
                    return [
                        2
                    ];
                });
            });
            return function onClick(e) {
                return _ref.apply(this, arguments);
            };
        }();
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, {
                onClick: onClick,
                isActive: props.isActive
            })
        });
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withWishList);


/***/ }),

/***/ 87947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ desktop_ReportPopup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./hooks/common/useOverlay.tsx + 1 modules
var useOverlay = __webpack_require__(91864);
// EXTERNAL MODULE: ./components/common/modal/alert/Desktop.tsx
var Desktop = __webpack_require__(64024);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
;// CONCATENATED MODULE: ./components/style/detailpackage/declaration.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 10px 0;\n	> textarea {\n		min-height: 200px;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: center;\n	margin-top: 30px;\n\n	> button + button {\n		margin-left: 10px;\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-top: 15px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 100%;\n	height: 45px;\n	ul {\n		left: -1px;\n		width: 510px;\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var TextareaWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3f1b4e35-0"
})(_templateObject());
var ButtonBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3f1b4e35-1"
})(_templateObject1());
var BulletList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-3f1b4e35-2"
})(_templateObject2());
var SelectWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3f1b4e35-3"
})(_templateObject3());


// EXTERNAL MODULE: ./framework/ui/desktop/button/index.ts + 7 modules
var desktop_button = __webpack_require__(9873);
// EXTERNAL MODULE: ./framework/ui/desktop/input/index.ts + 7 modules
var desktop_input = __webpack_require__(58127);
// EXTERNAL MODULE: ./framework/ui/desktop/list/index.ts + 3 modules
var desktop_list = __webpack_require__(73255);
// EXTERNAL MODULE: ./framework/ui/desktop/popup/index.ts + 2 modules
var popup = __webpack_require__(7794);
// EXTERNAL MODULE: ./framework/ui/desktop/select/index.ts
var desktop_select = __webpack_require__(64249);
// EXTERNAL MODULE: ./framework/ui/desktop/table/index.ts + 1 modules
var table = __webpack_require__(5540);
// EXTERNAL MODULE: ./hooks/services/queries/portal/usePortalCode.ts
var usePortalCode = __webpack_require__(95134);
// EXTERNAL MODULE: ./hooks/services/queries/portal/useReviewReport.ts
var useReviewReport = __webpack_require__(37006);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/product/common/popup/desktop/ReportPopup.tsx




















var debounce = function(callback, delay) {
    var timer;
    return function(contents) {
        clearTimeout(timer);
        timer = setTimeout(function() {
            return callback(contents);
        }, delay);
    };
};
var ReportPopup = function(props) {
    var ref;
    var reportId = props.reportId, reportType = props.reportType, overlayProps = (0,_object_without_properties/* default */.Z)(props, [
        "reportId",
        "reportType"
    ]);
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref1 = (0,react.useState)({
        reportId: String(reportId),
        reportType: reportType,
        reportCode: "",
        reportContents: ""
    }), report = ref1[0], setReport = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref2[0];
    var close = props.close;
    var code = (0,usePortalCode/* default */.ZP)("REPORT_CODE");
    var list = ((ref = code.data) === null || ref === void 0 ? void 0 : ref.body) || [];
    var input = (0,react.useCallback)(debounce(function(contents) {
        return setReport((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, report), {
            reportContents: contents
        }));
    }, 500), [
        report
    ]);
    var doConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var result, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (!report.reportContents) {
                            open(function(overlay) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* default */.Z, (0,_object_spread/* default */.Z)({
                                    text: "신고 사유를 입력해주세요."
                                }, overlay));
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            (0,useReviewReport/* reviewReportAsync */.sW)(report).catch(function(e) {
                                throw new Error();
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        result.data.code === "0000" && open(function(overlay) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                text: "게시글 신고 접수가 완료 되었습니다.<br/> 접수하신 신고사유 검토하여 빠른 시일내에 처리하겠습니다."
                            }, overlay), {
                                resolve: function(value) {
                                    if (value === true) {
                                        reportType === "REVIEW" && queryClient.refetchQueries({
                                            queryKey: [
                                                "useReview"
                                            ],
                                            type: "active"
                                        });
                                        reportType === "EPISODE" && queryClient.refetchQueries({
                                            queryKey: [
                                                "useReviewEpisodeDetail"
                                            ],
                                            type: "active"
                                        });
                                        close();
                                    }
                                }
                            }));
                        });
                        result.data.code !== "0000" && open(function(overlay) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                text: result.data.message.replace(/\n/g, "<br/>")
                            }, overlay), {
                                resolve: function(value) {
                                    if (value === true) {
                                        close();
                                    }
                                }
                            }));
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        open(function(prop) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                                text: "오류가 발생하였습니다."
                            }));
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function doConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    // 신고 사유 콤보 박스
    var id = (0,react.useId)();
    var ref3 = (0,react.useState)(false), showCode = ref3[0], setShowCode = ref3[1];
    var ref4 = (0,react.useState)({
        key: "",
        text: ""
    }), currentCode = ref4[0], setCurrentCode = ref4[1];
    var handleSelect = function(e) {
        setCurrentCode({
            key: e.target.getAttribute("value"),
            text: e.target.innerText
        });
        setReport((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, report), {
            reportCode: e.target.getAttribute("value")
        }));
    };
    (0,react.useEffect)(function() {
        if (code.isFetching) return;
        var ref = list.at(0), commCdId = ref.commCdId, commCdNm = ref.commCdNm;
        setCurrentCode({
            key: commCdId,
            text: commCdNm
        });
        setReport((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, report), {
            reportCode: commCdId
        }));
    }, [
        code.isFetching
    ]);
    (0,react.useEffect)(function() {
        if (!showCode) return;
        var event = function(e) {
            if (document.body.contains(e.target)) {
                !e.target.closest("#".concat(CSS.escape(id))) && setShowCode(false);
            }
        };
        setTimeout(function() {
            return window.addEventListener("click", event);
        });
        return function() {
            window.removeEventListener("click", event);
        };
    }, [
        showCode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popup/* PopupContainer */.k, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlayProps), {
        title: "신고하기",
        size: "regular",
        paddingTop: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableContainer */.x, {
                lineTop: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                        children: "신고하기"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                style: {
                                    width: "170px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                style: {
                                    width: "550px"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "신고사유"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectWrap, {
                                            id: id,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_select/* SelectBox */.jL, {
                                                onClick: function() {
                                                    return setShowCode(!showCode);
                                                },
                                                tabIndex: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectLabel */.n5, {
                                                        children: currentCode.text
                                                    }),
                                                    showCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectOptions */.PN, {
                                                        search: true,
                                                        children: list.map(function(param) {
                                                            var commCdId = param.commCdId, commCdNm = param.commCdNm;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                onClick: handleSelect,
                                                                value: commCdId,
                                                                children: commCdNm
                                                            }, commCdId);
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    colSpan: 2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextareaWrap, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_input/* Textarea */.gx, {
                                            cols: 30,
                                            placeholder: "신고 사유 항목에 없거나 추가로 신고하시고자 하는 내용을 작성해주세요.\n단, 신고내용 외 개인정보(연락처, 주소 등)는 절대 입력하지 마세요.",
                                            onChange: function(e) {
                                                return input(e.target.value);
                                            }
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletList, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_list/* BulletListItem */.yx, {
                    children: "신고해 주신 내용은 관리자 검토 후 내부정책에 의거 조치가 진행됩니다."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBlock, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* TextButton */.Av, {
                        text: "취소",
                        types: "basic",
                        size: "submit",
                        width: "basic",
                        onClick: close
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* TextButton */.Av, {
                        text: "신고",
                        types: "confirm",
                        size: "submit",
                        width: "basic",
                        onClick: doConfirm
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var desktop_ReportPopup = (ReportPopup);


/***/ }),

/***/ 55084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17550);
/* harmony import */ var _COMPONENTS_product_pages_detailPackage_desktop_schedule_Review__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1560);
/* harmony import */ var _COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5955);
/* harmony import */ var _FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9873);
/* harmony import */ var _QUERIES_portal_useReview__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3889);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);









var ReviewListPopupComponent = function(props) {
    var ref;
    var close = props.close, goodsCd = props.goodsCd, reviewOpen = props.reviewOpen;
    // 리뷰 리스트 조회
    var reviewDataFetch = (0,_QUERIES_portal_useReview__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(goodsCd);
    var reviewData = ((ref = reviewDataFetch.data) === null || ref === void 0 ? void 0 : ref.body) || null;
    // 리뷰 데이터 정제
    var originReview = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        var reviewList = reviewData.reviewList, attach = reviewData.attachList;
        return reviewList.reduce(function(acc, cur) {
            var attachList = attach.filter(function(v) {
                return v.reviewId === cur.reviewId;
            });
            var item = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, cur), {
                attachList: attachList
            });
            acc.push(item);
            return acc;
        }, []);
    }, [
        reviewData
    ]);
    var ref1;
    /** 사진&동영상 리스트 */ var galleries = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        return (ref1 = originReview === null || originReview === void 0 ? void 0 : originReview.filter(function(v) {
            var ref;
            return ((ref = v.attachList) === null || ref === void 0 ? void 0 : ref.length) > 0;
        })) !== null && ref1 !== void 0 ? ref1 : [];
    }, [
        originReview
    ]);
    // 스크롤 제거
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        document.body.style.overflowY = "hidden";
        return function() {
            document.body.style.removeProperty("overflow-y");
        };
    }, []);
    // 리뷰 상세 이동
    var handleClick = function(e, reviewId) {
        e.preventDefault();
        close();
        reviewOpen(reviewId, null);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_3__/* .Wrap */ .Eq, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_3__/* .Popup */ .GI, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_3__/* .Header */ .h4, {
                    line: false,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: "사진&동영상"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_4__/* .PopupCloseButton */ .sz, {
                            onClose: close
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_3__/* .Content */ .VY, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_3__/* .Gallery */ .ri, {
                        children: galleries.map(function(gallery) {
                            var reviewId = gallery.reviewId, attachList = gallery.attachList;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_3__/* .GalleryItem */ .Lm, {
                                    href: "#",
                                    onClick: function(e) {
                                        return handleClick(e, reviewId);
                                    },
                                    children: [
                                        attachList.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: attachList.length
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_product_pages_detailPackage_desktop_schedule_Review__WEBPACK_IMPORTED_MODULE_2__/* .ReviewThumbnail */ .Q, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, attachList[0]), {
                                            height: "122px",
                                            width: "122px"
                                        }))
                                    ]
                                })
                            }, reviewId);
                        })
                    })
                })
            ]
        })
    });
};
var ReviewListPopup = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReviewListPopupComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReviewListPopup);


/***/ }),

/***/ 87123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_common_useOverlay__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91864);
/* harmony import */ var _COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17550);
/* harmony import */ var _COMPONENTS_common_modal_alert_Desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64024);
/* harmony import */ var _COMPONENTS_product_pages_detailPackage_desktop_schedule_Review__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1560);
/* harmony import */ var _COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5955);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9873);
/* harmony import */ var _FRAMEWORK_ui_desktop_flag__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34869);
/* harmony import */ var _FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31267);
/* harmony import */ var _QUERIES_account_useSigninUser__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5142);
/* harmony import */ var _QUERIES_portal_useReview__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3889);
/* harmony import */ var _QUERIES_portal_useReviewLike__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(81258);
/* harmony import */ var _QUERIES_portal_useReviewLikeRecommender__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26163);
/* harmony import */ var _QUERIES_support_useReviewPictures__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64380);
/* harmony import */ var _yb_ui_desktop_common_Noimage__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(78860);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(67294);





















var ReviewImageVideo = function(attach) {
    var ref;
    var sevSaveDirNm = attach.sevSaveDirNm, sevSaveFileNm = attach.sevSaveFileNm, vimeoEndPoint = attach.vimeoEndPoint;
    // 이미지 리턴
    var imageUrl = sevSaveDirNm && sevSaveFileNm ? "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_6__/* ["default"].ENV_SCDN_URL */ .Z.ENV_SCDN_URL).concat(sevSaveDirNm, "/").concat(sevSaveFileNm) : null;
    var vimeoId = (vimeoEndPoint === null || vimeoEndPoint === void 0 ? void 0 : vimeoEndPoint.split("/")[2]) || null;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(null), vimeoUrl = ref1[0], setVimeoUrl = ref1[1];
    var reviewPictruesFetch = (0,_QUERIES_support_useReviewPictures__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(vimeoId, {
        enabled: !!vimeoId
    });
    var reviewPictrues = ((ref = reviewPictruesFetch.data) === null || ref === void 0 ? void 0 : ref.body) || null;
    (0,react__WEBPACK_IMPORTED_MODULE_16__.useEffect)(function() {
        if (reviewPictrues) setVimeoUrl(reviewPictrues.player_embed_url);
    }, [
        reviewPictrues
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: vimeoEndPoint && vimeoUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
            src: vimeoUrl,
            allow: "autoplay; fullscreen",
            width: "100%",
            height: "100%",
            frameBorder: "0"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yb_ui_desktop_common_Noimage__WEBPACK_IMPORTED_MODULE_17__/* .Noimage */ .T, {
            src: imageUrl,
            alt: ""
        })
    });
};
var ReviewPopupComponent = function(props) {
    var ref, ref1, ref2;
    var goodsCd = props.goodsCd, reviewId = props.reviewId, close = props.close, listOpen = props.listOpen, _optionAttach = props.optionAttach, optionAttach = _optionAttach === void 0 ? null : _optionAttach;
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_hooks_common_useOverlay__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), 1), open = ref3[0];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(reviewId), currentId = ref4[0], setCurrentId = ref4[1];
    // 선택된 이미지 default[0]
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(optionAttach), selectedAttach = ref5[0], setSelectedAttach = ref5[1];
    // 유저 정보 조회
    var signin = (0,_QUERIES_account_useSigninUser__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)();
    var signinCode = ((ref = signin.data) === null || ref === void 0 ? void 0 : ref.code) || "9999";
    // 리뷰 리스트 조회
    var reviewDataFetch = (0,_QUERIES_portal_useReview__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(goodsCd);
    var reviewData = ((ref1 = reviewDataFetch.data) === null || ref1 === void 0 ? void 0 : ref1.body) || null;
    // 리뷰 좋아요 조회 (로그인 유저)
    var reviewLikeRecommenderFetch = (0,_QUERIES_portal_useReviewLikeRecommender__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)(goodsCd, {
        enabled: signinCode === "0000"
    });
    var reviewLikeRecommender = ((ref2 = reviewLikeRecommenderFetch.data) === null || ref2 === void 0 ? void 0 : ref2.body) || [];
    var originReview = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        var reviewList = reviewData.reviewList, attach = reviewData.attachList;
        return reviewList.reduce(function(acc, cur) {
            var attachList = attach.filter(function(v) {
                return v.reviewId === cur.reviewId;
            }) || null;
            var item = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, cur), {
                attachList: attachList
            });
            acc.push(item);
            return acc;
        }, []);
    }, [
        reviewData
    ]);
    /** 사진&동영상 리스트 */ var galleries = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        if (!originReview) return [];
        var filteredReview = originReview.filter(function(v) {
            var ref;
            return ((ref = v.attachList) === null || ref === void 0 ? void 0 : ref.length) > 0;
        });
        var result = filteredReview.reduce(function(acc, cur, idx, src) {
            var ref, ref1;
            var prevReviewId = ((ref = src[idx - 1]) === null || ref === void 0 ? void 0 : ref.reviewId) || null;
            var nextReviewId = ((ref1 = src[idx + 1]) === null || ref1 === void 0 ? void 0 : ref1.reviewId) || null;
            var item = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, cur), {
                prevReviewId: prevReviewId,
                nextReviewId: nextReviewId
            });
            acc.push(item);
            return acc;
        }, []);
        return result;
    }, [
        originReview
    ]);
    var gallery = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        return galleries.find(function(v) {
            return v.reviewId === currentId;
        });
    }, [
        currentId,
        galleries
    ]);
    var _attachList;
    var attachList = (_attachList = gallery.attachList) !== null && _attachList !== void 0 ? _attachList : [];
    (0,react__WEBPACK_IMPORTED_MODULE_16__.useEffect)(function() {
        if (!selectedAttach) setSelectedAttach(attachList[0]);
    }, []);
    // 이전 리뷰
    var handlePrev = function() {
        setCurrentId(gallery.prevReviewId);
        var currentList = galleries.find(function(v) {
            return v.reviewId === gallery.prevReviewId;
        });
        if (currentList) setSelectedAttach(currentList.attachList[0]);
    };
    // 다음 리뷰
    var handleNext = function() {
        setCurrentId(gallery.nextReviewId);
        var currentList = galleries.find(function(v) {
            return v.reviewId === gallery.nextReviewId;
        });
        if (currentList) setSelectedAttach(currentList.attachList[0]);
    };
    // 이미지 클릭 이벤트
    var handleImageClick = function(attach) {
        return setSelectedAttach(attach);
    };
    // 추천하기(좋아요) 버튼
    var handleLike = function(reviewId) {
        if (signinCode === "0000") {
            (0,_QUERIES_portal_useReviewLike__WEBPACK_IMPORTED_MODULE_12__/* .reviewLikeAsync */ .oM)({
                goodsCd: goodsCd,
                reviewId: reviewId.toString()
            }).then(function(result) {
                if (result.data.code === "0000") {
                    reviewLikeRecommenderFetch.refetch();
                    reviewDataFetch.refetch();
                }
            });
        } else {
            open(function(prop) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_modal_alert_Desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, prop), {
                    alertType: "confirm",
                    text: "로그인 후 이용하실 수 있습니다. <br/>로그인하시겠습니까?",
                    afterConfirm: function() {
                        return LoginUtil.login();
                    }
                }));
            });
        }
    };
    // 스크롤 제거
    (0,react__WEBPACK_IMPORTED_MODULE_16__.useEffect)(function() {
        document.body.style.overflowY = "hidden";
        return function() {
            document.body.style.removeProperty("overflow-y");
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .Wrap */ .Eq, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .Popup */ .GI, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .Header */ .h4, {
                    line: false,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_9__/* .Flex */ .kC, {
                            gap: "20",
                            align: "end",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    children: "사진&동영상"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .ListLink */ .N_, {
                                    href: "#",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        listOpen();
                                        close();
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "전체보기"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_7__/* .PopupCloseButton */ .sz, {
                            onClose: close
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .DetailContent */ .s7, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .Media */ .pU, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReviewImageVideo, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, selectedAttach))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .ReviewContent */ .Lt, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .PreviewList */ .ol, {
                                    children: attachList.map(function(attach, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .PreviewItem */ .s8, {
                                            onClick: function() {
                                                return handleImageClick(attach);
                                            },
                                            $isSelected: selectedAttach === attach,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_product_pages_detailPackage_desktop_schedule_Review__WEBPACK_IMPORTED_MODULE_4__/* .ReviewThumbnail */ .Q, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, attach))
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .ReviewInfo */ .aB, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .ReviewTopBar */ .lv, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .ScoreWrap */ .lW, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_flag__WEBPACK_IMPORTED_MODULE_8__/* .StarScore */ .xo, {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                style: {
                                                                    width: "calc(".concat(gallery.score, "*20%)")
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                                            children: gallery.score
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .ReviewerProfile */ .Yg, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .UserName */ .vx, {
                                                            children: [
                                                                gallery.custNm,
                                                                "님"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .ProfileDetails */ .og, {
                                                            children: [
                                                                gallery.ageNm && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: gallery.ageNm
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: gallery.companionNm
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .DetailDate */ .Pd, {
                                                    dateTime: dayjs__WEBPACK_IMPORTED_MODULE_15___default()(gallery.reviewDt).format("YYYY.MM.DD"),
                                                    children: dayjs__WEBPACK_IMPORTED_MODULE_15___default()(gallery.reviewDt).format("YYYY.MM.DD")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .Highlights */ .xK, {
                                            children: gallery.keywords && gallery.keywords.split(",").map(function(keyword, index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_16__.Fragment, {
                                                    children: keyword && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .HighlightItem */ .Hl, {
                                                        children: keyword
                                                    })
                                                }, index);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .ReviewText */ .lb, {
                                            dangerouslySetInnerHTML: {
                                                __html: gallery.detail.replace(/\n/g, "<br />")
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .FeedbackControls */ .nM, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .RecommendBtnWrap */ .FR, {
                                                onClick: function() {
                                                    return handleLike(gallery.reviewId);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .RecommendBtnIcon */ .aw, {
                                                        $isActive: !!reviewLikeRecommender.find(function(v) {
                                                            return v.reviewId === gallery.reviewId;
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .RecommendBtn */ .Vp, {
                                                        children: "추천"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .LikeCount */ .oU, {
                                                        children: gallery.likeCnt
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                gallery.prevReviewId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .SlideButton */ .At, {
                    direction: "prev",
                    onClick: handlePrev,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "이전 여행후기 보기"
                    })
                }),
                gallery.nextReviewId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviewpopup__WEBPACK_IMPORTED_MODULE_5__/* .SlideButton */ .At, {
                    direction: "next",
                    onClick: handleNext,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "다음 여행후기 보기"
                    })
                })
            ]
        })
    });
};
var ReviewPopup = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReviewPopupComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, props))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReviewPopup);


/***/ }),

/***/ 36017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sd": function() { return /* binding */ DetailCoupon; },
  "nX": function() { return /* binding */ DetailNotice; },
  "dD": function() { return /* binding */ DetailPrice; },
  "ZP": function() { return /* binding */ desktop_DetailContents; }
});

// UNUSED EXPORTS: DetailBanner

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./hooks/common/useCountdown.tsx
var useCountdown = __webpack_require__(71392);
// EXTERNAL MODULE: ./hooks/common/useOverlay.tsx + 1 modules
var useOverlay = __webpack_require__(91864);
// EXTERNAL MODULE: ./hooks/common/useTagging.ts + 5 modules
var useTagging = __webpack_require__(40070);
// EXTERNAL MODULE: ./components/common/commonUtil.ts
var commonUtil = __webpack_require__(2576);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./components/common/eventUtil.ts
var eventUtil = __webpack_require__(99346);
// EXTERNAL MODULE: ./components/common/goodsUtil.ts
var goodsUtil = __webpack_require__(68284);
// EXTERNAL MODULE: ./components/common/modal/alert/Desktop.tsx
var Desktop = __webpack_require__(64024);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./framework/ui/desktop/button/index.ts + 7 modules
var desktop_button = __webpack_require__(9873);
// EXTERNAL MODULE: ./framework/ui/desktop/popup/index.ts + 2 modules
var popup = __webpack_require__(7794);
// EXTERNAL MODULE: ./framework/ui/desktop/table/index.ts + 1 modules
var table = __webpack_require__(5540);
// EXTERNAL MODULE: ./framework/ui/desktop/text/index.ts + 2 modules
var desktop_text = __webpack_require__(81499);
// EXTERNAL MODULE: ./framework/ui/desktop/input/index.ts + 7 modules
var input = __webpack_require__(58127);
// EXTERNAL MODULE: ./framework/ui/desktop/list/index.ts + 3 modules
var list = __webpack_require__(73255);
// EXTERNAL MODULE: ./framework/ui/desktop/print/Print.tsx
var Print = __webpack_require__(27205);
// EXTERNAL MODULE: ./framework/ui/desktop/editor/index.tsx
var editor = __webpack_require__(58771);
// EXTERNAL MODULE: ./components/style/detailpackage/keyinformation.tsx
var keyinformation = __webpack_require__(74761);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/@yb/utils/dist/ybutil.cjs.js
var ybutil_cjs = __webpack_require__(20279);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventOptionalTourDetail.ts
var useEventOptionalTourDetail = __webpack_require__(39810);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./framework/utils/useConfigureAxios.ts + 43 modules
var useConfigureAxios = __webpack_require__(21741);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/popup/KeyInformationPop.tsx























var KeyInformationPopComponent = function(props) {
    var ref, ref1;
    var event = props.event, price = props.price, overlayProps = (0,_object_without_properties/* default */.Z)(props, [
        "event",
        "price"
    ]);
    var evNm = event.evNm, evStartDt = event.evStartDt, evArriveDt = event.evArriveDt, startCharDivi = event.startCharDivi, goodsTp = event.goodsTp, minCnt = event.minCnt, webCancelCommiYn = event.webCancelCommiYn, webStartConfYn = event.webStartConfYn, shopCnt = event.shopCnt;
    var evCd = event.evCd, webTourDayYn = event.webTourDayYn, webGoodsPriceYn = event.webGoodsPriceYn, webAirConfYn = event.webAirConfYn, webGuidConfYn = event.webGuidConfYn, webAccommConfYn = event.webAccommConfYn, webInsolConfYn = event.webInsolConfYn;
    var adtPrice = price.adtPrice, bafAdtCost = price.bafAdtCost, chdPrice = price.chdPrice, bafChdCost = price.bafChdCost, infPrice = price.infPrice, bafInfCost = price.bafInfCost;
    var guideExpAmt = price.guideExpAmt, expCurrCd = price.expCurrCd, driverAmt = price.driverAmt, airTaxAdtCost = price.airTaxAdtCost, airTaxChdCost = price.airTaxChdCost, airTaxInfCost = price.airTaxInfCost;
    var totalPice = (0,eventUtil/* getPrice */.aS)(price);
    var useEventOptTourDtl = (0,useEventOptionalTourDetail/* default */.Z)(evCd);
    var evtOptTourDtl = (ref = useEventOptTourDtl.data) === null || ref === void 0 ? void 0 : ref.body;
    var shop = (evtOptTourDtl === null || evtOptTourDtl === void 0 ? void 0 : evtOptTourDtl.shopList) || [];
    var shopInfo = evtOptTourDtl === null || evtOptTourDtl === void 0 ? void 0 : (ref1 = evtOptTourDtl.optionalTourInfo) === null || ref1 === void 0 ? void 0 : ref1.shopInfo;
    var isFH = (0,eventUtil/* isGoodsTpFH */.mk)(goodsTp); // 허니문 에어텔 여부
    var ref2 = (0,react.useState)(null), safety = ref2[0], setSafety = ref2[1]; // 안전정보
    /* 안전 정보 api */ var SafetyInfoAsync = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            (0,useConfigureAxios/* default */.Z)((_tmp.url = "".concat(config_public/* default.ENV_CHORUS_API_BASEPATH */.Z.ENV_CHORUS_API_BASEPATH, "/trvSafe/selectTrvSafe"), _tmp.method = "POST", _tmp.data = {
                                compId: "1",
                                evCd: evCd
                            }, _tmp)).then(function(result) {
                                if (result.data.errorCode === "0") {
                                    var ref;
                                    var res = (ref = result.data.trvSafeList) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, cur) {
                                        var attentionNote = cur.attentionNote, controlNote = cur.controlNote, limitaNote = cur.limitaNote, banNote = cur.banNote, splimitNote = cur.splimitNote, naKorNm = cur.naKorNm, trvSafeUpdDt = cur.trvSafeUpdDt;
                                        attentionNote && (acc.attInfo += "[".concat(naKorNm, "] ").concat(attentionNote, " <br/>"));
                                        controlNote && (acc.cntlInfo += "[".concat(naKorNm, "] ").concat(controlNote, " <br/>"));
                                        limitaNote && (acc.limtInfo += "[".concat(naKorNm, "] ").concat(limitaNote, " <br/>"));
                                        banNote && (acc.banNote += "[".concat(naKorNm, "] ").concat(banNote, " <br/>"));
                                        splimitNote && (acc.splimitInfo += "[".concat(naKorNm, "] ").concat(splimitNote, " <br/>"));
                                        acc.safeDate === "" && (acc.safeDate += trvSafeUpdDt);
                                        return acc;
                                    }, {
                                        attInfo: "",
                                        cntlInfo: "",
                                        limtInfo: "",
                                        banNote: "",
                                        splimitInfo: "",
                                        safeDate: ""
                                    });
                                    setSafety(res);
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function SafetyInfoAsync() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        SafetyInfoAsync();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Print/* default */.ZP, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popup/* PopupContainer */.k, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlayProps), {
            title: "여행상품 핵심정보",
            size: "large",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* BtnArea */.Z7, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* TextButton */.Av, {
                        text: "인쇄하기",
                        size: "default",
                        onClick: function() {
                            return window.print();
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Print/* PrintArea */.An, {
                    id: "printPopup",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableContainer */.x, {
                            line: false,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                                    children: "여행상품 핵심 정보"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "18%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "32%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "18%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "32%"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "상품명"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    colSpan: 3,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* ProductTitle */.tc, {
                                                        children: evNm
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "여행 기간"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                    children: [
                                                        dayjs_min_default()(evStartDt).format("YYYY.MM.DD"),
                                                        " ~ ",
                                                        dayjs_min_default()(evArriveDt).format("YYYY.MM.DD")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "상품종류"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* RadioList */.rL, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                    htmlFor: "01",
                                                                    disabled: true,
                                                                    defaultChecked: startCharDivi === "10",
                                                                    children: "단독상품"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                    htmlFor: "02",
                                                                    disabled: true,
                                                                    defaultChecked: startCharDivi === "20",
                                                                    children: "연합상품"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "영업보증보험"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "가입"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "기획여행 보증보험"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "가입"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* SubTitle */.DK, {
                            children: "여행경비"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* ExpensesTable */.DL, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                                    children: "여행경비"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "17%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "17%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "22%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "22%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "22%"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "col",
                                                    colSpan: 2,
                                                    children: "구분"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "col",
                                                    children: "성인"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "col",
                                                    children: "아동"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "col",
                                                    children: "유아"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* ExpensesTd */.si, {
                                                    rowSpan: airTaxAdtCost + airTaxChdCost + airTaxInfCost > 0 ? 4 : 3,
                                                    line: true,
                                                    children: "상품가"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* ExpensesTd */.si, {
                                                    children: "기본 상품가"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    children: [
                                                        ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(adtPrice),
                                                        " 원"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    children: [
                                                        ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(chdPrice),
                                                        " 원"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    children: [
                                                        ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(infPrice),
                                                        " 원"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* ExpensesTd */.si, {
                                                    children: "유류할증료"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    children: [
                                                        ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(bafAdtCost),
                                                        " 원"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    children: [
                                                        ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(bafChdCost),
                                                        " 원"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    children: [
                                                        ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(bafInfCost),
                                                        " 원"
                                                    ]
                                                })
                                            ]
                                        }),
                                        airTaxAdtCost + airTaxChdCost + airTaxInfCost > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* ExpensesTd */.si, {
                                                    children: "TAX"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    children: [
                                                        ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(airTaxAdtCost),
                                                        " 원"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    children: [
                                                        ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(airTaxChdCost),
                                                        " 원"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    children: [
                                                        ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(airTaxInfCost),
                                                        " 원"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* ExpensesTd */.si, {
                                                    line: true,
                                                    children: "소계"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    line: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* RedText */.xK, {
                                                        children: !isFH ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("em", {
                                                            children: [
                                                                ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(totalPice.adult),
                                                                " 원"
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: totalPice.adult > 0 ? "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(totalPice.adult), " 원") : "별도문의"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    line: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* RedText */.xK, {
                                                        children: !isFH ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("em", {
                                                            children: [
                                                                ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(totalPice.child),
                                                                " 원"
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: totalPice.child > 0 ? "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(totalPice.child), " 원") : "별도문의"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    line: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* RedText */.xK, {
                                                        children: !isFH ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("em", {
                                                            children: [
                                                                ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(totalPice.infant),
                                                                " 원"
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: totalPice.infant > 0 ? "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(totalPice.infant), " 원") : "별도문의"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* ExpensesTd */.si, {
                                                    rowSpan: 3,
                                                    line: true,
                                                    children: "현지필수경비"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* ExpensesTd */.si, {
                                                    children: "현지필수경비"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    children: [
                                                        guideExpAmt,
                                                        " ",
                                                        expCurrCd
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    children: [
                                                        driverAmt,
                                                        " ",
                                                        expCurrCd
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    children: "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* ExpensesTd */.si, {
                                                    line: true,
                                                    children: "소계"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    line: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* RedText */.xK, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("em", {
                                                            children: [
                                                                guideExpAmt,
                                                                " ",
                                                                expCurrCd
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    line: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* RedText */.xK, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("em", {
                                                            children: [
                                                                driverAmt,
                                                                " ",
                                                                expCurrCd
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* ExpensesTd */.si, {
                                                    align: "right",
                                                    line: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* RedText */.xK, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "-"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* BulletList */.DY, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* BulletListItem */.yx, {
                                children: "유류할증료 및 TAX는 유가 및 환율 등에 따라 변동될 수 있으며, 아동/유아 기준은 항공사마다 상이하여 예약 후 최종 확정됩니다."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* SubTitle */.DK, {
                            children: "최소 출발 인원 및 수수료 정보"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableContainer */.x, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                                    children: "최소 출발 인원 및 수수료 정보"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "18%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "26%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "20%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "36%"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "row",
                                                children: "최소 출발 인원 기준"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                children: [
                                                    minCnt,
                                                    "명"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "row",
                                                children: "취소수수료 부과 기준"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* RadioList */.rL, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                htmlFor: "03",
                                                                disabled: true,
                                                                defaultChecked: webCancelCommiYn === "Y",
                                                                children: "표준약관 적용"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                htmlFor: "04",
                                                                disabled: true,
                                                                defaultChecked: webCancelCommiYn === "N",
                                                                children: "특별약관 적용"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* BulletList */.DY, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* BulletListItem */.yx, {
                                    children: "최소출발인원 미충족 시 여행약관 제9조에 따라 여행출발 7일전까지 여행사는 여행계약을 일방적으로 해제하고 여행자에게 통보할 수 있습니다."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* BulletListItem */.yx, {
                                    children: "취소수수료는 계약금 입금일부터 적용됩니다. 취소수수료 부과 세부 기준을 반드시 확인하세요."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* BulletListItem */.yx, {
                                    children: "특별약관 적용의 경우, 표준약관보다 높은 취소수료가 부과될 수 있으며, 별도의 동의 절차를 거치게 됩니다."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* SubTitle */.DK, {
                            children: "주요 확정/미정 정보"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableContainer */.x, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                                    children: "주요 확정/미정 정보"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "18%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "26%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "20%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "36%"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "출발"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* RadioList */.rL, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                    htmlFor: "03",
                                                                    disabled: true,
                                                                    defaultChecked: webStartConfYn === "Y",
                                                                    children: "확정"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                    htmlFor: "04",
                                                                    disabled: true,
                                                                    defaultChecked: webStartConfYn === "N",
                                                                    children: "미정"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "여행일정"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* RadioList */.rL, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                    htmlFor: "03",
                                                                    disabled: true,
                                                                    defaultChecked: webTourDayYn === "Y",
                                                                    children: "확정"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                    htmlFor: "04",
                                                                    disabled: true,
                                                                    defaultChecked: webTourDayYn === "N",
                                                                    children: "예정"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "상품가격"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* RadioList */.rL, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                    htmlFor: "03",
                                                                    disabled: true,
                                                                    defaultChecked: webGoodsPriceYn === "Y",
                                                                    children: "확정"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                    htmlFor: "04",
                                                                    disabled: true,
                                                                    defaultChecked: webGoodsPriceYn === "N",
                                                                    children: "미정"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "항공"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* RadioList */.rL, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                    htmlFor: "03",
                                                                    disabled: true,
                                                                    defaultChecked: webAirConfYn === "Y",
                                                                    children: "확정"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                    htmlFor: "04",
                                                                    disabled: true,
                                                                    defaultChecked: webAirConfYn === "N",
                                                                    children: "예정"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "숙박"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* RadioList */.rL, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                    htmlFor: "03",
                                                                    disabled: true,
                                                                    defaultChecked: webAccommConfYn === "Y",
                                                                    children: "확정"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                    htmlFor: "04",
                                                                    disabled: true,
                                                                    defaultChecked: webAccommConfYn === "N",
                                                                    children: "미정"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "가이드"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* RadioList */.rL, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                    htmlFor: "03",
                                                                    disabled: true,
                                                                    defaultChecked: webGuidConfYn === "Y",
                                                                    children: "있음"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                    htmlFor: "04",
                                                                    disabled: true,
                                                                    defaultChecked: webGuidConfYn === "N",
                                                                    children: "없음"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "인솔자"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    colSpan: 3,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* RadioList */.rL, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                    htmlFor: "03",
                                                                    disabled: true,
                                                                    defaultChecked: webInsolConfYn === "Y",
                                                                    children: "동반"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Radio */.Y8, {
                                                                    htmlFor: "04",
                                                                    disabled: true,
                                                                    defaultChecked: webInsolConfYn === "N",
                                                                    children: "미동반"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        shop && shop.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* SubTitle */.DK, {
                                    children: [
                                        "쇼핑 정보",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* TableInfoText */.pY, {
                                            children: [
                                                "아래 쇼핑 품목 중 총 ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("em", {
                                                    children: [
                                                        shopCnt,
                                                        "번"
                                                    ]
                                                }),
                                                "의 쇼핑센터 방문이 일정에 포함되어 있습니다.(쇼핑 품목은 여행일정에 따라 달라질 수 있습니다.)"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableContainer */.x, {
                                    types: "vertical",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                                            children: "쇼핑 정보"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                    style: {
                                                        width: "12%"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                    style: {
                                                        width: "36%"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                    style: {
                                                        width: "20%"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                    style: {
                                                        width: "12%"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                    style: {
                                                        width: "20%"
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        scope: "col",
                                                        children: "회차"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        scope: "col",
                                                        children: "쇼핑 목록"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        scope: "col",
                                                        children: "쇼핑 장소"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        scope: "col",
                                                        children: "소요시간"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        scope: "col",
                                                        children: "환불 여부"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                            children: shop.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: index + 1
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: item.shopNm
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: item.shopPlace
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: item.shopTm
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: item.refundNote
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        shopInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                shop.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* SubTitle */.DK, {
                                    children: "쇼핑 정보"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* EditorWrap */.ls, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                        dangerouslySetInnerHTML: {
                                            __html: shopInfo
                                        }
                                    })
                                })
                            ]
                        }),
                        safety && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* SubTitle */.DK, {
                                    children: [
                                        "여행지 안전 정보",
                                        safety.safeDate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* TableInfoText */.pY, {
                                            children: [
                                                "기준일시 : ",
                                                dayjs_min_default()(safety.safeDate).format("YYYY.MM.DD HH:mm:ss")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableContainer */.x, {
                                    types: "vertical",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                                            children: "여행지 안전 정보"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                    style: {
                                                        width: "20%"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                    style: {
                                                        width: "20%"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                    style: {
                                                        width: "60%"
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            scope: "col",
                                                            colSpan: 2,
                                                            children: "여행경보단계"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            scope: "col",
                                                            children: "여행지(국가 또는 지역)"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "남색경보"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "여행유의"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* LocationText */.aX, {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: safety.attInfo || "-"
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "황색경보"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "여행자제"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* LocationText */.aX, {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: safety.cntlInfo || "-"
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "적색경보"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "철수권고"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* LocationText */.aX, {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: safety.limtInfo || "-"
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "흑색경보"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "여행금지"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* LocationText */.aX, {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: safety.banNote || "-"
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                            colSpan: 2,
                                                            children: [
                                                                "특별 여행주의보",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* InfoText */.XU, {
                                                                    children: "※ 단기적으로 긴급한 위험이 있는 국가(지역)에 대하여 발령합니다."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(keyinformation/* LocationText */.aX, {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: safety.splimitInfo || "-"
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(keyinformation/* BulletList */.DY, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(list/* BulletListItem */.yx, {
                                            children: [
                                                "특별여행주의보 발령에 따른 행동요령은 여행경보 2단계 이상 3단계 이하에 준합니다.",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "(예) (여행예정자) 여행취소\xb7연기, (체류자) 신변안전 특별유의",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "특별여행주의보 발령 기간은 90일을 넘지 않습니다."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* BulletListItem */.yx, {
                                            children: "외교부에서는 [여행경보제도]를 운영하고 있으며, 노랑풍선은 고객님의 안전한 해외여행을 위하여 이 정보를 제공하고 있습니다. 여행경보단계는 여행유의/자제/철수권고/금지 4단계로 구분되며, 단기적인 위험상황이 발생하는 경우 특별여행주의보/경보 2단계로 추가 구분하고 있습니다."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(list/* BulletListItem */.yx, {
                                            children: [
                                                "외교부에서 국가별 상황에 따라 상시로 [여행경보제도]의 변경이 있을 수 있으므로, 당사에서 제공하는 안전정보가 시점에 따라 다소 차이가 발생할 수 있사오니, 반드시 출국 전 여행목적지의(국가 및 지역,",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://www.0404.go.kr/dev/main.mofa",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "www.0404.go.kr"
                                                }),
                                                ") 안전정보를 확인하시어 [외교부의 권고]를 따라주시기 바랍니다."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        }))
    });
};
/** 여행상품 핵심정보 */ var KeyInformationPop = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "Popup KeyInformationPop Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyInformationPopComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var popup_KeyInformationPop = (KeyInformationPop);

// EXTERNAL MODULE: ./components/style/detailpackage/itinerary.tsx
var itinerary = __webpack_require__(88393);
// EXTERNAL MODULE: ./framework/ui/desktop/icon/AirlineIcon.tsx
var AirlineIcon = __webpack_require__(38502);
// EXTERNAL MODULE: ./framework/ui/desktop/layout/index.tsx + 2 modules
var layout = __webpack_require__(31267);
// EXTERNAL MODULE: ./public/P/images/ico/ico_nodata.png
var ico_nodata = __webpack_require__(39044);
var ico_nodata_default = /*#__PURE__*/__webpack_require__.n(ico_nodata);
// EXTERNAL MODULE: ./hooks/services/queries/account/useSigninUser.ts
var useSigninUser = __webpack_require__(5142);
// EXTERNAL MODULE: ./hooks/services/queries/bff/global/useGlobalGoodsLive.ts
var useGlobalGoodsLive = __webpack_require__(28906);
// EXTERNAL MODULE: ./hooks/services/queries/bff/global/useGlobalMenu.ts
var useGlobalMenu = __webpack_require__(98653);
// EXTERNAL MODULE: ./hooks/services/queries/essential/banner/useBannerContents.ts
var useBannerContents = __webpack_require__(72204);
// EXTERNAL MODULE: ./hooks/services/queries/essential/banner/useBannerGoodsDeal.ts
var useBannerGoodsDeal = __webpack_require__(82767);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/coupon/useCouponByEvent.ts
var useCouponByEvent = __webpack_require__(93381);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/coupon/useCouponDown.ts
var useCouponDown = __webpack_require__(46894);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventFirstDisplay.ts
var useEventFirstDisplay = __webpack_require__(48052);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventPrice.ts
var useEventPrice = __webpack_require__(8745);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventScheduleTrip.ts
var useEventScheduleTrip = __webpack_require__(28963);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventTourDetail.ts
var useEventTourDetail = __webpack_require__(93113);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isBetween.js
var isBetween = __webpack_require__(66607);
var isBetween_default = /*#__PURE__*/__webpack_require__.n(isBetween);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/DetailContents.tsx









































var daykor = [
    "일",
    "월",
    "화",
    "수",
    "목",
    "금",
    "토"
];
var BannerYellowPangDeal = function(props) {
    var deal = props.deal;
    var netThroughValues = {
        clickArea: "yellowpangdeal",
        banner: "ypd_deal_goods_banner"
    };
    var PangdealText = function() {
        var targetDate = dayjs_min_default()(deal.dealEdTm).add(1, "minute");
        var countdown = (0,useCountdown/* default */.Z)(targetDate);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* PangdealText */.Kr, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* PangdealProduct */.pb, {
                            children: deal.dealType === "T" ? "타임특가" : "선착순특가"
                        }),
                        "\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* PangdealDate */.Q0, {
                            children: deal.dealType === "T" ? countdown !== null && countdown !== void 0 ? countdown : "종료" : "상품 ".concat(deal.dealRervCnt || 0, "개")
                        }),
                        countdown !== null && " 남음"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "".concat(deal.dealRervCnt > 0 || countdown !== null ? "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(deal.price - deal.dealGoodsPrice), "원 즉시할인가격") : "")
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* BannerYellowpangdeal */.yn, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            target: "_self",
            href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/promotion/yellowPangDeal.yb"),
            onClick: function() {
                nLogger.event("ds_click", {
                    _n_click_area: netThroughValues.clickArea,
                    _n_banner: netThroughValues.banner,
                    _n_contents: props.goodsCd,
                    _n_contents_nm: props.goodsNm
                });
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* PangdealPrice */.G_, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PangdealText, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* PangdealLink */.rV, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "전체보기"
                    })
                })
            ]
        })
    });
};
var BannerYellowLive = function(param) {
    var live = param.live;
    dayjs_min_default().extend((isBetween_default())); // isBetween 사용
    var dspYn = live.dspYn, liveDt = live.liveDt, liveTime = live.liveTime;
    // 방송 노출 조건 Y가 아닌 경우 - 노출 X
    if (dspYn !== "Y") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var liveStartDate = dayjs_min_default()(liveDt);
    var liveEndDate = liveStartDate.add(Number(liveTime), "minute");
    var today = dayjs_min_default()();
    var LiveText = function() {
        if (today.isBefore(liveStartDate)) {
            var countdown = (0,useCountdown/* default */.Z)(liveStartDate);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* LiveDate */.Uq, {
                        children: "COMING SOON"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* LiveState */.kE, {
                        children: countdown
                    })
                ]
            });
        } else if (today.isBetween(liveStartDate, liveEndDate)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* LiveDate */.Uq, {
                        children: "ON AIR"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* LiveState */.kE, {
                        children: "실시간 방송 중"
                    })
                ]
            });
        } else {
            var formattedDate = "".concat(liveStartDate.format("MM/DD"), "(").concat(daykor[liveStartDate.day()], ") ").concat(liveStartDate.format("HH:mm"));
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* LiveDate */.Uq, {
                        children: formattedDate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* LiveState */.kE, {
                        children: "방영 완료"
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* BannerYellowLive */.$g, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: "".concat(config_public/* default.ENV_PORTAL_URL */.Z.ENV_PORTAL_URL, "/promotion/yellowLive"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* LiveText */.sS, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* LiveTit */.TH, {
                            children: "최대 혜택으로 떠나는 생생한 여행"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveText, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* LiveLink */.Ge, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "바로가기"
                    })
                })
            ]
        })
    });
};
var DetailBannerComponent = function(props) {
    var ref, ref1, ref2;
    var bannerContentsFetch = (0,useBannerContents/* default */.ZP)("GOPM"); // WEB_CONT_DIVI_CD 상품상세_요금영역
    var bannerContents = (ref = bannerContentsFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    var bannerDealFetch = (0,useBannerGoodsDeal/* default */.ZP)(props.goodsCd);
    var bannerDeal = (ref1 = bannerDealFetch.data) === null || ref1 === void 0 ? void 0 : ref1.body;
    var bannerLiveFetch = (0,useGlobalGoodsLive/* default */.Z)(props.goodsCd);
    var bannerLive = (ref2 = bannerLiveFetch.data) === null || ref2 === void 0 ? void 0 : ref2.body;
    var imageOnError = function(e) {
        e.currentTarget.src = (ico_nodata_default());
        e.currentTarget.className = "img-error";
    };
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_select_promo_dtl", {
        selectDiv: "MiddtlBanner"
    }).taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* EventBanner */.cK, {
                children: bannerContents && bannerContents.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL).concat(item.link),
                        target: (0,commonUtil/* getTarget */.U9)(item.target),
                        onClick: function() {
                            return taggingClick(item);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(config_public/* default.ENV_CIMG_CDN_URL */.Z.ENV_CIMG_CDN_URL).concat(item.imgPath),
                            alt: item.alt,
                            onError: imageOnError
                        })
                    }, index);
                })
            }),
            bannerDeal && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerYellowPangDeal, {
                deal: bannerDeal,
                goodsCd: props.goodsCd,
                goodsNm: props.goodsNm
            }),
            bannerLive && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerYellowLive, {
                live: bannerLive
            })
        ]
    });
};
var DetailBanner = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailContents DetailBanner Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailBannerComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
var DetailNoticeComponent = function(props) {
    var ref, ref1;
    var eventDetail = props.eventDetail, query = props.query, _usePrintView = props.usePrintView, usePrintView = _usePrintView === void 0 ? false : _usePrintView;
    var goodsAreaOne = eventDetail.evCd.substring(0, 1);
    var evCd = eventDetail.evCd, goodsCd = eventDetail.goodsCd, simpleScheYn = eventDetail.simpleScheYn, outUseTmhh = eventDetail.outUseTmhh, outUseTmmi = eventDetail.outUseTmmi, inUseTmhh = eventDetail.inUseTmhh, inUseTmmi = eventDetail.inUseTmmi;
    var scheduleTripFetch = (0,useEventScheduleTrip/* default */.Z)(evCd, goodsCd);
    var tourDetailsFetch = (0,useEventTourDetail/* default */.Z)(evCd);
    /** 간략 일정 더보기 */ var ref2 = (0,react.useState)(usePrintView), showMore = ref2[0], setShowMore = ref2[1];
    var buttonText = showMore ? "접기" : "더 보기";
    var handleScheduleButton = function() {
        setShowMore(!showMore);
    };
    var simpleDays = (0,react.useMemo)(function() {
        var ref;
        if (!scheduleTripFetch.isFetched || !tourDetailsFetch.isFetched) return null;
        var _body = scheduleTripFetch.data.body, scheduleDetail = _body.scheduleDetail, scheduleDetailTm = _body.scheduleDetailTm;
        var tourDetails = (ref = tourDetailsFetch.data) === null || ref === void 0 ? void 0 : ref.body;
        var result = scheduleDetail.map(function(detail) {
            var dayTmList = scheduleDetailTm.filter(function(tm) {
                tm.tourDetails = tourDetails.filter(function(v) {
                    return v.tmSeq === tm.tmSeq;
                });
                return tm.dayNo === detail.dayNo;
            });
            var cities = dayTmList.reduce(function(accCity, city) {
                // 이미 Array에 등록된 바로 이전 city
                var recentIndex = accCity.length - 1 || 0;
                var prevCity = accCity.length > 0 && accCity[recentIndex].code === city.cityCd ? accCity[recentIndex] : null;
                if (prevCity) {
                    var _trvInfoNm;
                    var combined = {
                        code: city.cityCd,
                        city: city.cityNm,
                        tourlist: (0,_to_consumable_array/* default */.Z)(prevCity.tourlist).concat((0,_to_consumable_array/* default */.Z)(city.tourDetails.map(function(item) {
                            return "".concat(item.trvCd === "70" ? "[선택관광]" : "").concat((_trvInfoNm = item.trvInfoNm) !== null && _trvInfoNm !== void 0 ? _trvInfoNm : "");
                        })))
                    };
                    accCity.splice(recentIndex, 1, combined);
                } else {
                    var _trvInfoNm1;
                    var tourlist = city.tourDetails.map(function(item) {
                        return "".concat(item.trvCd === "70" ? "[선택관광]" : "").concat((_trvInfoNm1 = item.trvInfoNm) !== null && _trvInfoNm1 !== void 0 ? _trvInfoNm1 : "");
                    });
                    accCity.push({
                        code: city.cityCd,
                        city: city.cityNm,
                        tourlist: tourlist
                    });
                }
                return accCity;
            }, []);
            return {
                dayNo: detail.dayNo,
                dayNote: detail.dayNote,
                cities: cities
            };
        });
        return result;
    }, [
        scheduleTripFetch,
        tourDetailsFetch
    ]);
    var location = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!scheduleTripFetch.isFetched) return null;
        var scheduleDetailTm = (ref = scheduleTripFetch.data) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.scheduleDetailTm;
        return (0,eventUtil/* flightLocation */.MO)(scheduleDetailTm, goodsAreaOne);
    }, [
        scheduleTripFetch
    ]);
    // 여행상품 핵심정보 팝업
    var usePrice = (0,useEventPrice/* default */.ZP)(evCd);
    var price = (ref = usePrice.data) === null || ref === void 0 ? void 0 : ref.body;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref3[0];
    var openKeyInformation = function() {
        open(function(overlay) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(popup_KeyInformationPop, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlay), {
                event: eventDetail,
                price: price
            }));
        });
    };
    /** 예약현황 */ var firstDisplay = (0,useEventFirstDisplay/* default */.ZP)(evCd).data.body;
    var globalMenu = (ref1 = (0,useGlobalMenu/* default */.Z)().data) === null || ref1 === void 0 ? void 0 : ref1.body;
    var menuLv2List = globalMenu.menuLv2List;
    var isReserveCount = (0,react.useMemo)(function() {
        var ref;
        if (!menuLv2List) return;
        var dspSid = (query === null || query === void 0 ? void 0 : query.dspSid) ? "".concat((ref = query.dspSid) === null || ref === void 0 ? void 0 : ref.slice(0, -4), "0000") : (firstDisplay === null || firstDisplay === void 0 ? void 0 : firstDisplay.dspSid2) || "";
        var targetMenu = menuLv2List.find(function(v) {
            return v.dspSid === dspSid;
        });
        return targetMenu ? targetMenu.tempRervCntYn : null;
    }, [
        menuLv2List,
        firstDisplay
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* SubTitleFlexWrap */.UE, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* SubTitle */.DK, {
                        children: "여행 주요일정"
                    }),
                    !usePrintView && /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* TextButton */.Av, {
                        text: "여행상품 핵심정보",
                        size: "default",
                        onClick: openKeyInformation
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* SimpleItinerary */.Jw, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ItineraryTable */.WW, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                                    children: "여행 상품 주요일정 요약"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "16.91%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                            style: {
                                                width: "83.09%"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "일정"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* ItineraryAirplaneInfo */.ox, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* AirplaneInfoContent */.DF, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                                                        align: "flex-start",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneDepart */.cB, {
                                                                                children: "출발"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                                                                direction: "column",
                                                                                gap: "10",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                                                                        align: "center",
                                                                                        children: [
                                                                                            eventDetail.trTp ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AirlineIcon/* default */.Z, {
                                                                                                img: (0,eventUtil/* getTrafficIconUrl */.wz)(eventDetail),
                                                                                                title: "".concat(eventDetail.trCompanyNm, " ").concat(eventDetail.seatClassCd && eventDetail.seatClassCd !== "EC" ? "(".concat(eventDetail.seatClassNm, ")") : "")
                                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                                children: "교통불포함"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneNumber */.bp, {
                                                                                                children: eventDetail.outFlightNm
                                                                                            }),
                                                                                            (0,eventUtil/* scheduleTimeText */.fP)({
                                                                                                hh: outUseTmhh,
                                                                                                mi: outUseTmmi
                                                                                            }) && /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneTime */.v9, {
                                                                                                children: (0,eventUtil/* scheduleTimeText */.fP)({
                                                                                                    hh: outUseTmhh,
                                                                                                    mi: outUseTmmi
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                                                                        align: "center",
                                                                                        children: [
                                                                                            (location === null || location === void 0 ? void 0 : location.outDeprtCityNm) && /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneName */.Vr, {
                                                                                                children: location.outDeprtCityNm
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneDay */.j8, {
                                                                                                children: (0,eventUtil/* departureStart */.jn)(eventDetail)
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneIcon */.IX, {}),
                                                                                            (location === null || location === void 0 ? void 0 : location.outArrvCityNm) && /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneName */.Vr, {
                                                                                                children: location.outArrvCityNm
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneDay */.j8, {
                                                                                                children: (0,eventUtil/* departureArrival */.t9)(eventDetail)
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                                                        align: "flex-start",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneDepart */.cB, {
                                                                                children: "도착"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                                                                direction: "column",
                                                                                gap: "10",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                                                                        align: "center",
                                                                                        children: [
                                                                                            eventDetail.trTp ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AirlineIcon/* default */.Z, {
                                                                                                img: (0,eventUtil/* getTrafficIconUrl */.wz)(eventDetail),
                                                                                                title: "".concat(eventDetail.trCompanyNm, " ").concat(eventDetail.seatClassCd && eventDetail.seatClassCd !== "EC" ? "(".concat(eventDetail.seatClassNm, ")") : "")
                                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                                children: "교통불포함"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneNumber */.bp, {
                                                                                                children: eventDetail.inFlightNm
                                                                                            }),
                                                                                            (0,eventUtil/* scheduleTimeText */.fP)({
                                                                                                hh: inUseTmhh,
                                                                                                mi: inUseTmmi
                                                                                            }) && /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneTime */.v9, {
                                                                                                children: (0,eventUtil/* scheduleTimeText */.fP)({
                                                                                                    hh: inUseTmhh,
                                                                                                    mi: inUseTmmi
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                                                                        align: "center",
                                                                                        children: [
                                                                                            (location === null || location === void 0 ? void 0 : location.inDeprtCityNm) && /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneName */.Vr, {
                                                                                                children: location.inDeprtCityNm
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneDay */.j8, {
                                                                                                children: (0,eventUtil/* returnStart */.sm)(eventDetail)
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneIcon */.IX, {}),
                                                                                            (location === null || location === void 0 ? void 0 : location.inArrvCityNm) && /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneName */.Vr, {
                                                                                                children: location.inArrvCityNm
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneDay */.j8, {
                                                                                                children: (0,eventUtil/* returnArrival */.jp)(eventDetail)
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            evCd.substring(0, 2) === "KJ" && /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* AirplaneInfoCaution */.T1, {
                                                                children: "해당 시간은 예정 항공 스케줄이므로 항공사 및 항공시간 변동 가능성이 있습니다. 예약확정 안내 시 정확한 스케줄은 재안내 드립니다."
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        eventDetail.accomNm && eventDetail.webDisplayCls === "B" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "옵션"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: eventDetail.accomNm
                                                })
                                            ]
                                        }),
                                        isReserveCount === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "예약현황"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* StatusList */.ip, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(list/* StackListItem */.jS, {
                                                                children: [
                                                                    "예약:\xa0\xa0",
                                                                    eventDetail.rervCnt + eventDetail.fakeCnt - eventDetail.cancelCnt,
                                                                    "석"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(list/* StackListItem */.jS, {
                                                                children: [
                                                                    "남은 좌석:\xa0\xa0",
                                                                    eventDetail.avlilBlockQty,
                                                                    "석 (최소출발 ",
                                                                    eventDetail.minCnt,
                                                                    "명)"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        eventDetail.keypointContList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "여행포인트"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: eventDetail.keypointContList.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                            children: [
                                                                item.kpointCont,
                                                                eventDetail.keypointContList.length !== index + 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                            ]
                                                        }, index);
                                                    })
                                                })
                                            ]
                                        }),
                                        eventDetail.tourPatInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "row",
                                                    children: "방문도시"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* VisitingCityText */.MT, {
                                                        children: eventDetail.tourPatInfo.replace(/\n/g, "").split("-").map(function(item, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: item
                                                            }, index);
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    simpleScheYn === "Y" && simpleDays && simpleDays.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* ScheduleWrap */.HA, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ScheduleListWrap */.ix, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ScheduleList */.xA, {
                                    children: simpleDays.map(function(item, index) {
                                        var ItemCount = 3;
                                        return (index < ItemCount || showMore) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* ScheduleListDay */.hC, {
                                                    children: [
                                                        item.dayNo,
                                                        "일차"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* ScheduleSummary */.JJ, {
                                                    children: [
                                                        item.cities.map(function(city, citiesIdx) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* BlueText */.IW, {
                                                                        children: city.city
                                                                    }),
                                                                    city.tourlist && /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* TouristSpot */.qt, {
                                                                        children: city.tourlist.map(function(spot, spotIdx) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                children: spot
                                                                            }, spotIdx);
                                                                        })
                                                                    })
                                                                ]
                                                            }, citiesIdx);
                                                        }),
                                                        item.dayNote && /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ScheduleNotice */.PS, {
                                                            children: item.dayNote
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, index);
                                    })
                                })
                            }),
                            !usePrintView && simpleDays.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_button/* PlusMoreButton */.sp, {
                                onClick: handleScheduleButton,
                                children: [
                                    "간략 일정 ",
                                    buttonText
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var DetailNotice = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailContents DetailNotice Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailNoticeComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
var DetailCouponComponent = function(props) {
    var ref;
    var evCd = props.evCd, _usePrintView = props.usePrintView, usePrintView = _usePrintView === void 0 ? false : _usePrintView;
    var CouponByEventFetch = (0,useCouponByEvent/* default */.ZP)(evCd);
    var coupon = (ref = CouponByEventFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    var ref1 = (0,useSigninUser/* default */.ZP)(), loginInfo = ref1.data;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref2[0];
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("goods_down_coupon", {
        evCd: evCd,
        selectDiv: "MiddtlButton"
    }).taggingClick;
    var handleCoupon = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(coupon) {
            var couponNo, body, _tmp, result, data, _tmp1, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        couponNo = coupon.couponNo;
                        if (!((loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.code) !== "0000")) return [
                            3,
                            1
                        ];
                        open(function(prop) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                                alertType: "confirm",
                                text: "로그인 후 이용하실 수 있습니다. <br/>로그인하시겠습니까?",
                                afterConfirm: function() {
                                    return LoginUtil.login();
                                }
                            }));
                        });
                        return [
                            3,
                            4
                        ];
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        taggingClick(coupon);
                        _tmp = {};
                        body = (_tmp.compId = "1", _tmp.webCustNo = loginInfo.body.webCustNo, _tmp.couponNo = couponNo, _tmp);
                        return [
                            4,
                            (0,useCouponDown/* default */.Z)(body)
                        ];
                    case 2:
                        result = _state.sent();
                        data = result.data;
                        _tmp1 = {};
                        if (data.errorCode === "0000") {
                            open(function(prop) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                                    text: data.errorMsg
                                }));
                            });
                            queryClient.refetchQueries((_tmp1.queryKey = [
                                "useCouponByEvent"
                            ], _tmp1.type = "active", _tmp1));
                        } else if (data.errorCode === "2004") {
                            open(function(prop) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                                    text: "이미 쿠폰을 발급받으셨습니다."
                                }));
                            });
                        } else {
                            alert(data.errorMsg);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        alert("오류가 발생하였습니다.");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCoupon(coupon) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: coupon && coupon.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* SubTitleFlexWrap */.UE, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* SubTitle */.DK, {
                            children: "사용 가능 쿠폰"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* CouponTotalText */.N2, {
                            children: [
                                "총 ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                    children: coupon.length
                                }),
                                "건"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* CouponList */.hO, {
                    children: coupon.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* CouponItem */.hc, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* CouponIcon */.zc, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        children: "COUPON"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* CouponTitle */.E9, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* CouponPrice */.WQ, {
                                            children: item.discDiviCd === "M" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                                                children: [
                                                    ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(item.discAmt),
                                                    "원"
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                                                children: [
                                                    item.discRate,
                                                    "%"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* CouponName */.uW, {
                                            children: item.couponNm
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* CouponButtonWrap */.d8, {
                                    children: [
                                        item.validityDiviCd === "DD" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* CouponExpired */.Cx, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "발급일로부터 ",
                                                    item.validityDday,
                                                    "일 유효"
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* CouponExpired */.Cx, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    dayjs_min_default()(item.validityFrDt).format("YYYY.MM.DD"),
                                                    " ~",
                                                    " ",
                                                    dayjs_min_default()(item.validityToDt).format("YYYY.MM.DD")
                                                ]
                                            })
                                        }),
                                        !usePrintView && /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* TextButton */.Av, {
                                            types: "basic",
                                            size: "default",
                                            text: "다운로드",
                                            onClick: function() {
                                                return handleCoupon(item);
                                            }
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(list/* BulletListItem */.yx, {
                        children: [
                            "해당 쿠폰은 행사 전용 혜택으로, 회원 등급별 쿠폰을 다운받으시려면\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* TextLink */.hh, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/mypage/memberGrade.yb"),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "이곳"
                                })
                            }),
                            "을 클릭해주세요."
                        ]
                    })
                })
            ]
        })
    });
};
var DetailCoupon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailContents DetailCoupon Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailCouponComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
var DetailPriceComponent = function(props) {
    var ref;
    var eventDetail = props.eventDetail;
    var eventPriceFetch = (0,useEventPrice/* default */.ZP)(eventDetail.evCd);
    var eventPrice = (ref = eventPriceFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    var price = (0,eventUtil/* getPrice */.aS)(eventPrice);
    var TdPrice = function(param) {
        var _type = param.type, type = _type === void 0 ? "adult" : _type;
        var amount = {
            adult: {
                price: price.adult,
                baf: eventPrice.bafAdtCost,
                air: eventPrice.airTaxAdtCost
            },
            child: {
                price: price.child,
                baf: eventPrice.bafChdCost,
                air: eventPrice.airTaxChdCost
            },
            infant: {
                price: price.infant,
                baf: eventPrice.bafInfCost,
                air: eventPrice.airTaxInfCost
            }
        };
        var cost = amount[type];
        var isFH = (0,eventUtil/* isGoodsTpFH */.mk)(eventDetail.goodsTp);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: !isFH ? /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* PriceBox */.bz, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("em", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: price && ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(cost.price)
                                }),
                                "원"
                            ]
                        }),
                        (cost.baf > 0 || cost.air > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "세금 및 유류할증료 ".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(cost.baf + cost.air), "원 포함")
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: cost.price > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* PriceBox */.bz, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("em", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: price && ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(cost.price)
                                }),
                                "원"
                            ]
                        }),
                        (cost.baf > 0 || cost.air > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "세금 및 유류할증료 ".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(cost.baf + cost.air), "원 포함")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* PriceBox */.bz, {
                    children: "별도문의"
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* SubTitleFlexWrap */.UE, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* SubTitle */.DK, {
                        children: "상품가"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* CouponTotalText */.N2, {
                        children: [
                            "(예약금)",
                            " ",
                            eventPrice.depositAmt === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: "별도안내"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: "".concat(eventPrice.depositDivi ? eventPrice.depositDiviNm : "", " ").concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(eventPrice.depositAmt), "원")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ProductPriceTable */.tG, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableContainer */.x, {
                    lineTop: true,
                    types: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                            children: "상품가 안내"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                    style: {
                                        width: "140px"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                    style: {
                                        width: "254px"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                    style: {
                                        width: "254px"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                    style: {
                                        width: "254px"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            children: "구분"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* AgeLimitBox */.lD, {
                                                children: [
                                                    "성인 ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "(만 12세 이상)"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* AgeLimitBox */.lD, {
                                                children: [
                                                    "아동 ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "(만 2세 ~ 만 12세 미만)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* AgeLimit */.NP, {
                                                        children: [
                                                            (0,goodsUtil/* getChdAgeRange */.j1)({
                                                                evStartDt: eventDetail.evStartDt
                                                            }).join(" ~ "),
                                                            " 출생"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* AgeLimitBox */.lD, {
                                                children: [
                                                    "유아 ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "(만 2세 미만)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* AgeLimit */.NP, {
                                                        children: [
                                                            (0,goodsUtil/* getInfAgeRange */.M2)({
                                                                evStartDt: eventDetail.evStartDt
                                                            }).join(" ~ "),
                                                            " 출생"
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: "총 상품가"
                                        }),
                                        price && /*#__PURE__*/ (0,jsx_runtime.jsx)(TdPrice, {}),
                                        price && /*#__PURE__*/ (0,jsx_runtime.jsx)(TdPrice, {
                                            type: "child"
                                        }),
                                        price && /*#__PURE__*/ (0,jsx_runtime.jsx)(TdPrice, {
                                            type: "infant"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* BulletListItem */.yx, {
                    children: "유류할증료 및 TAX는 유가 및 환율 등에 따라 변동될 수 있으며, 아동/유아 기준은 항공사마다 상이하여 예약 후 최종 확정됩니다."
                })
            })
        ]
    });
};
var DetailPrice = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailContents DetailPrice Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailPriceComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
var DetailContentsComponent = function(props) {
    var eventDetail = props.eventDetail, goodsDetail = props.goodsDetail, query = props.query;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailNotice, {
                eventDetail: eventDetail,
                query: query
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailBanner, {
                goodsCd: goodsDetail.goodsCd,
                goodsNm: goodsDetail.goodsNm
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailPrice, {
                eventDetail: eventDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailCoupon, {
                evCd: eventDetail.evCd
            })
        ]
    });
};
var DetailContents = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailContents Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailContentsComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var desktop_DetailContents = (DetailContents);



/***/ }),

/***/ 29624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ desktop_DetailHeader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./hooks/common/useOverlay.tsx + 1 modules
var useOverlay = __webpack_require__(91864);
// EXTERNAL MODULE: ./hooks/common/useTagging.ts + 5 modules
var useTagging = __webpack_require__(40070);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./components/common/eventUtil.ts
var eventUtil = __webpack_require__(99346);
// EXTERNAL MODULE: ./components/common/flag/Desktop.tsx
var Desktop = __webpack_require__(76031);
// EXTERNAL MODULE: ./components/common/modal/share/Desktop.tsx + 3 modules
var share_Desktop = __webpack_require__(90451);
// EXTERNAL MODULE: ./components/hoc/withWishList.tsx
var withWishList = __webpack_require__(40198);
// EXTERNAL MODULE: ./components/product/common/popup/desktop/ReviewListPopup.tsx
var ReviewListPopup = __webpack_require__(55084);
// EXTERNAL MODULE: ./components/product/common/popup/desktop/ReviewPopup.tsx
var ReviewPopup = __webpack_require__(87123);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./framework/ui/desktop/text/index.ts + 2 modules
var desktop_text = __webpack_require__(81499);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
// EXTERNAL MODULE: ./public/P/images/ico/ico_spr.png
var ico_spr = __webpack_require__(99653);
var ico_spr_default = /*#__PURE__*/__webpack_require__.n(ico_spr);
;// CONCATENATED MODULE: ./components/style/detailpackage/bestreviews.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	margin: 60px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	margin-right: 10px;\n	font-family: "pr-font-bold";\n	&::before {\n		display: inline-block;\n		width: 20px;\n		height: 20px;\n		margin-right: 6px;\n		background: url(',
        ') no-repeat -284px 0px;\n		content: "";\n	}\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-top: 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 25px 20px;\n	height: 180px;\n	border: 1px solid var(--line-color);\n	border-radius: 12px;\n	box-sizing: border-box;\n	cursor: pointer;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	line-height: 1;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	margin-left: 9px;\n	font-family: "pr-font-bold";\n	font-size: 16px;\n	color: var(--emp-color);\n'
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nheight: 72px;\n	margin-top: 12px;\n	",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: end;\n	gap: 10px;\n	margin-top: 14px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--emp-color);\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: var(--basic-size);\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	top: 0;\n	right: 0;\n	width: 60px;\n	height: 30px;\n	border: 1px solid var(--line-color);\n	border-radius: 15px;\n	box-sizing: border-box;\n\n	button {\n		position: relative;\n		top: 0;\n		left: 10px;\n		width: 20px;\n		height: 100%;\n		background-color: transparent;\n\n		&:after {\n			position: absolute;\n			top: 9px;\n			display: block;\n			width: 7px;\n			height: 7px;\n			border-top: 1px solid #222;\n			border-right: 1px solid #222;\n			font-size: 0;\n			content: "";\n		}\n		&:disabled {\n			&:after {\n				border-color: var(--bl-color);\n			}\n		}\n	}\n'
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n	",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	cursor: pointer;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: inline-block;\n	width: 7px;\n	height: 7px;\n	margin-top: 0;\n	margin-left: 14px;\n	border-top: 1px solid var(--emp-color);\n	border-left: 1px solid var(--emp-color);\n	transform: rotate(135deg);\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}



var Wrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-46b58fc1-0"
})(_templateObject());
var Rating = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-46b58fc1-1"
})(_templateObject1(), (ico_spr_default()));
var SlideWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-46b58fc1-2"
})(_templateObject2());
var SlideContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-46b58fc1-3"
})(_templateObject3());
var ScoreWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-46b58fc1-4"
})(_templateObject4());
var Score = styled_components_browser_esm/* default.em.withConfig */.ZP.em.withConfig({
    componentId: "sc-46b58fc1-5"
})(_templateObject5());
var Content = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-46b58fc1-6"
})(_templateObject6(), (0,desktop_text/* Ellipsis */.mH)(3));
var MetaInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-46b58fc1-7"
})(_templateObject7());
var UserName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-46b58fc1-8"
})(_templateObject8());
var bestreviews_Date = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-46b58fc1-9"
})(_templateObject9());
var SlideButtonWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-46b58fc1-10"
})(_templateObject10());
var SlideButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-46b58fc1-11"
})(_templateObject11(), function(props) {
    return props.direction === "next" && "&:after {\n        right: 7px;\n        transform: rotate(45deg);\n    }";
}, function(props) {
    return props.direction === "prev" && "&:after {\n		left: 5px;\n		transform: rotate(-135deg);\n	}";
});
var SubTitleWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-46b58fc1-12"
})(_templateObject12());
var ArrowIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-46b58fc1-13"
})(_templateObject13());


// EXTERNAL MODULE: ./components/style/detailpackage/itinerary.tsx
var itinerary = __webpack_require__(88393);
// EXTERNAL MODULE: ./components/style/slide/index.tsx
var slide = __webpack_require__(91587);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./framework/ui/desktop/button/index.ts + 7 modules
var desktop_button = __webpack_require__(9873);
// EXTERNAL MODULE: ./framework/ui/desktop/flag/index.ts
var flag = __webpack_require__(34869);
// EXTERNAL MODULE: ./framework/ui/desktop/layout/index.tsx + 2 modules
var layout = __webpack_require__(31267);
// EXTERNAL MODULE: ./framework/ui/desktop/list/index.ts + 3 modules
var list = __webpack_require__(73255);
// EXTERNAL MODULE: ./framework/ui/desktop/slide/index.ts + 6 modules
var desktop_slide = __webpack_require__(93774);
// EXTERNAL MODULE: ./hooks/services/queries/account/useSigninUser.ts
var useSigninUser = __webpack_require__(5142);
// EXTERNAL MODULE: ./hooks/services/queries/essential/customer/useWishlist.ts
var useWishlist = __webpack_require__(61817);
// EXTERNAL MODULE: ./hooks/services/queries/portal/useReview.ts
var useReview = __webpack_require__(3889);
// EXTERNAL MODULE: ./hooks/services/queries/portal/useReviewSummary.ts
var useReviewSummary = __webpack_require__(56088);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventPrice.ts
var useEventPrice = __webpack_require__(8745);
// EXTERNAL MODULE: ./node_modules/@yb/ui/desktop/common/Noimage/index.cjs
var Noimage = __webpack_require__(78860);
// EXTERNAL MODULE: ./node_modules/@yb/utils/dist/ybutil.cjs.js
var ybutil_cjs = __webpack_require__(20279);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./components/product/pages/detailPackage/desktop/popup/ImageVideoPop.tsx
var ImageVideoPop = __webpack_require__(44240);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/DetailHeader.tsx




































var IconListComponent = function(props) {
    var eventDetail = props.eventDetail;
    var evStaCd = eventDetail.evStaCd, avlilBlockQty = eventDetail.avlilBlockQty;
    var avlilBlockQtyText = (0,react.useMemo)(function() {
        var result = "";
        if (evStaCd !== "05") {
            if (avlilBlockQty > 0) {
                result = "잔여 ".concat(avlilBlockQty, "석");
            } else if (avlilBlockQty === 0) {
                result = "잔여석 대기";
            }
        } else if (avlilBlockQty > 0) {
            result = "잔여 ".concat(avlilBlockQty, "석");
        } else if (avlilBlockQty === 0) {
            result = "잔여석 마감";
        }
        return result;
    }, [
        eventDetail
    ]);
    var traffic = (0,eventUtil/* getTrafficIcon */.HG)(eventDetail);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* ScheduleIconList */.sy, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ScheduleIcon */._w, {
                        icon: "schedule"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: eventDetail.dayStayInfo.split("박").join("박 ")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ScheduleIcon */._w, {
                        icon: traffic.icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            traffic.name,
                            traffic.icon === "air-premium" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    eventDetail.seatClassNm
                                ]
                            }),
                            eventDetail.stopoverCntYn === "Y" && !(eventDetail.outStovCnt === 0 && eventDetail.inStovCnt === 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "출국 ",
                                    eventDetail.outStovCnt > 0 ? "경유".concat(eventDetail.outStovCnt, "회") : "직항",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "귀국 ",
                                    eventDetail.inStovCnt > 0 ? "경유".concat(eventDetail.inStovCnt, "회") : "직항"
                                ]
                            })
                        ]
                    })
                ]
            }),
            [
                "07",
                "08",
                "11"
            ].includes(eventDetail.evProgDivi) && eventDetail.goodsTp !== "G" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ScheduleIcon */._w, {
                        icon: "decide"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: eventDetail.evProgDiviNm
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ScheduleIcon */._w, {
                        icon: "guide"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            eventDetail.webGuidConfYn === "Y" && eventDetail.webInsolConfYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    "가이드포함",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "인솔자동행"
                                ]
                            }),
                            eventDetail.webGuidConfYn === "N" && eventDetail.webInsolConfYn === "N" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    "가이드불포함",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "인솔자미동행"
                                ]
                            }),
                            eventDetail.webGuidConfYn === "Y" && eventDetail.webInsolConfYn === "N" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: "가이드포함"
                            }),
                            eventDetail.webGuidConfYn === "N" && eventDetail.webInsolConfYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: "인솔자동행"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ScheduleIcon */._w, {
                        icon: "expenses"
                    }),
                    eventDetail.guideExpAmt ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "가이드기사",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            eventDetail.expCurrCd,
                            " ",
                            ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(eventDetail.guideExpAmt)
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "가이드기사",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "경비없음"
                        ]
                    })
                ]
            }),
            !(0,eventUtil/* isGoodsTpFH */.mk)(eventDetail.goodsTp) && eventDetail.goodsTp !== "G" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ScheduleIcon */._w, {
                        icon: "seat"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            avlilBlockQtyText,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "최소출발 ",
                            eventDetail.minCnt,
                            "명"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ScheduleIcon */._w, {
                        icon: "insurance"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: eventDetail.webCancelCommiYn === "N" ? "특별약관" : "표준약관"
                    })
                ]
            }),
            eventDetail.singleChagYn === "Y" && eventDetail.singleChagAmt !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ScheduleIcon */._w, {
                        icon: "charge"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "싱글차지",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(eventDetail.singleChagAmt),
                            "원"
                        ]
                    })
                ]
            }),
            eventDetail.freeScheYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ScheduleIcon */._w, {
                        icon: "free"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "자유일정",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "있음"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ScheduleIcon */._w, {
                        icon: "shopping"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "쇼핑 ",
                            eventDetail.shopCnt > 0 ? "".concat(eventDetail.shopCnt, "회") : "없음"
                        ]
                    })
                ]
            }),
            eventDetail.greenFeeYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ScheduleIcon */._w, {
                        icon: "green"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "그린피",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "포함"
                        ]
                    })
                ]
            }),
            eventDetail.caddieFeeYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* ScheduleIcon */._w, {
                        icon: "caddy"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "캐디피",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "포함"
                        ]
                    })
                ]
            })
        ]
    });
};
/** 픽토그램 */ var IconList = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailHeader IconList Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconListComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
var ReviewSummary = function(props) {
    var reviewData = props.reviewData, reviewSummary = props.reviewSummary, goodsCd = props.goodsCd;
    var originReview = (0,react.useMemo)(function() {
        var reviewList = reviewData.reviewList, attach = reviewData.attachList;
        return reviewList.reduce(function(acc, cur) {
            var attachList = attach.filter(function(v) {
                return v.reviewId === cur.reviewId;
            });
            var item = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cur), {
                attachList: attachList
            });
            acc.push(item);
            return acc;
        }, []);
    }, [
        reviewData
    ]);
    /** 리뷰 조건(사진/영상 리뷰 3개이상 10개까지 노출, 최신리뷰 별점 높은순) */ var reviews = (0,react.useMemo)(function() {
        return originReview.filter(function(v) {
            var ref;
            return ((ref = v.attachList) === null || ref === void 0 ? void 0 : ref.length) > 0 && v.score >= 4;
        }) // 사진/영상 리뷰, 4점 이상
        .sort(function(a, b) {
            return dayjs_min_default()(b.reviewDt).valueOf() - dayjs_min_default()(a.reviewDt).valueOf();
        }) // 최신 리뷰 순
        .sort(function(a, b) {
            return b.score - a.score;
        }) // 별점 높은순
        .slice(0, 10);
    }, [
        originReview
    ]);
    // 상세 팝업
    var ref = (0,react.useState)(null), detailReviewId = ref[0], setDetailReviewId = ref[1];
    var handleReviewOpen = function(reviewId) {
        return setDetailReviewId(reviewId);
    };
    var handleReviewClose = function() {
        return setDetailReviewId(null);
    };
    // 리스트 팝업
    var ref1 = (0,react.useState)(false), isListPopup = ref1[0], setIsListPopup = ref1[1];
    var handleReviewListOpen = function() {
        return setIsListPopup(true);
    };
    var handleReviewListClose = function() {
        return setIsListPopup(false);
    };
    var handleScroll = function() {
        var reviewsElement = document.getElementById("reviews");
        if (reviewsElement) {
            reviewsElement.click();
            var observer = new MutationObserver(function(mutations, obs) {
                if (reviewsElement.offsetHeight > 0) {
                    reviewsElement.scrollIntoView({
                        behavior: "smooth"
                    });
                    obs.disconnect();
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    };
    var _scoreAvg;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            reviews.length > 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubTitleWrap, {
                        onClick: handleScroll,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_text/* SubTitle */.DK, {
                                onClick: function() {
                                    var link = document.querySelector('a[href="#content3"]');
                                    if (link) link.click();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: (_scoreAvg = reviewSummary.scoreAvg) !== null && _scoreAvg !== void 0 ? _scoreAvg : " - "
                                        })
                                    }),
                                    "실제 여행객 ".concat(reviewSummary.reviewCnt, "명의 리뷰 보기")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlideWrap, {
                        children: [
                            reviews.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideButtonWrap, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideButton, {
                                            className: "btn-prev",
                                            direction: "prev"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideButton, {
                                            className: "btn-next",
                                            direction: "next"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                slidesPerView: 3,
                                spaceBetween: 20,
                                navigation: {
                                    nextEl: ".btn-next",
                                    prevEl: ".btn-prev"
                                },
                                modules: [
                                    swiper_esm/* Navigation */.W_
                                ],
                                children: reviews.map(function(item, index) {
                                    var custNm = item.custNm, detail = item.detail, score = item.score, reviewDt = item.reviewDt, reviewId = item.reviewId;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlideContent, {
                                            onClick: function() {
                                                return handleReviewOpen(reviewId);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScoreWrap, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(flag/* StarScore */.xo, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                style: {
                                                                    width: "calc(".concat(score, "*20%)")
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Score, {
                                                            children: score
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                                                    dangerouslySetInnerHTML: {
                                                        __html: detail.replace(/\n/g, "<br />")
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MetaInfo, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserName, {
                                                            children: [
                                                                custNm,
                                                                "님"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bestreviews_Date, {
                                                            children: dayjs_min_default()(reviewDt).format("YYYY.MM.DD")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            }),
            detailReviewId && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewPopup/* default */.Z, {
                goodsCd: goodsCd,
                reviewId: detailReviewId,
                close: handleReviewClose,
                listOpen: handleReviewListOpen
            }),
            isListPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewListPopup/* default */.Z, {
                goodsCd: goodsCd,
                close: handleReviewListClose,
                reviewOpen: handleReviewOpen
            })
        ]
    });
};
var reviewSummaryDefault = {
    reviewCnt: 0,
    scoreAvg: 0,
    companion: "",
    companionNm: "",
    companionAttr1: "",
    companionAttr2: "",
    keywordList: []
};
var DetailHeaderComponent = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var eventDetail = props.eventDetail, goodsDetail = props.goodsDetail, goodsImage = props.goodsImage, goodsVideo = props.goodsVideo, _useScheduleView = props.useScheduleView, useScheduleView = _useScheduleView === void 0 ? false : _useScheduleView, _usePrintView = props.usePrintView, usePrintView = _usePrintView === void 0 ? false : _usePrintView;
    var router = (0,next_router.useRouter)();
    var dspSid = (ref = router.query) === null || ref === void 0 ? void 0 : ref.dspSid;
    var menu = (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.menu;
    /** 로그인 정보 */ var useSign = (0,useSigninUser/* default */.ZP)();
    var signinCode = ((ref2 = useSign.data) === null || ref2 === void 0 ? void 0 : ref2.code) || "9999";
    var webCustNo = ((ref3 = useSign.data) === null || ref3 === void 0 ? void 0 : ref3.body.webCustNo) || "";
    /** 리뷰 서머리 정보 */ var reviewSummaryFetch = (0,useReviewSummary/* default */.ZP)(eventDetail.goodsCd);
    var reviewSummary = ((ref4 = reviewSummaryFetch.data) === null || ref4 === void 0 ? void 0 : ref4.body) || reviewSummaryDefault;
    /** 리뷰 리스트 조회 */ var reviewDataFetch = (0,useReview/* default */.ZP)(eventDetail.goodsCd);
    var reviewData = ((ref5 = reviewDataFetch.data) === null || ref5 === void 0 ? void 0 : ref5.body) || null;
    /** 위시리스트 */ var useWish = (0,useWishlist/* default */.Z)(webCustNo, {
        enabled: !!webCustNo,
        throwOnError: false
    });
    var wishlist = ((ref6 = useWish.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.body) === null || ref7 === void 0 ? void 0 : ref7.wishProductsResultList) || [];
    var isWishNo = ((ref9 = (ref8 = wishlist.filter(function(wish) {
        return wish.evCd === eventDetail.evCd;
    })) === null || ref8 === void 0 ? void 0 : ref8.at(0)) === null || ref9 === void 0 ? void 0 : ref9.productWishId) || "";
    var eventPriceFetch = (0,useEventPrice/* default */.ZP)(eventDetail.evCd);
    var price = (0,eventUtil/* getPrice */.aS)((ref10 = eventPriceFetch.data) === null || ref10 === void 0 ? void 0 : ref10.body);
    var WishList = (0,withWishList/* default */.Z)(function(prop) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* IconButton */.hU, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                icon: "wishList"
            }, prop), {
                children: "찜"
            }))
        });
    });
    // 이미지 상세 팝업
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref11[0];
    var handleGoodsImageVideo = function() {
        open(function(prop) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageVideoPop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                images: goodsImage,
                videos: goodsVideo,
                title: "여행지 이미지 상세 보기"
            }));
        });
    };
    // 공유하기
    var handleShare = function() {
        open(function(prop) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(share_Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                parameter: "menu=".concat(menu, "&dspSid=").concat(dspSid, "&evCd=").concat(eventDetail.evCd)
            }));
        });
    };
    // 문의하기
    var hanldeQna = function() {
        var path = "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/qnaWrite.yb?evCd=").concat(eventDetail.evCd);
        if (signinCode === "0000") {
            location.href = path;
        } else {
            var text = "로그인 후 이용하실 수 있습니다. <br/>로그인하시겠습니까?";
            MessageUtil.confirm(text, function() {
                return LoginUtil.login(path);
            });
        }
    };
    /** 인쇄하기 */ var handlePrint = function() {
        window.open("/product/schedule/print?evCd=".concat(eventDetail.evCd));
    };
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_select_evCd_wish", eventDetail).taggingClick;
    var ref12;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* Wrap */.Eq, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                    gap: "3",
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* FlagGoodsTp */.B2, {
                                            goodsTp: eventDetail.goodsTp
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* FlagEmpasisCd */.k0, {
                                            emphasisCd: eventDetail.emphasisDivi
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* FlagEvProgDivi */.X, {
                                            evProgDivi: eventDetail.evProgDivi,
                                            evProgDiviNm: eventDetail.evProgDiviNm
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* ProductNumber */.l8, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(list/* StackListItem */.jS, {
                                            children: [
                                                "상품번호",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* TextNumber */.Mi, {
                                                    children: eventDetail.evCd
                                                })
                                            ]
                                        }),
                                        !useScheduleView && /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* StackListItem */.jS, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "#",
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    var link = document.querySelector('a[href="#content3"]');
                                                    if (link) link.click();
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: (reviewSummary === null || reviewSummary === void 0 ? void 0 : reviewSummary.scoreAvg) > 0 ? reviewSummary === null || reviewSummary === void 0 ? void 0 : reviewSummary.scoreAvg : " - "
                                                    }),
                                                    "/5 (리뷰 ".concat((ref12 = reviewSummary === null || reviewSummary === void 0 ? void 0 : reviewSummary.reviewCnt) !== null && ref12 !== void 0 ? ref12 : 0, "건)")
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        !useScheduleView && /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* ButtonBox */.KN, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* IconButton */.hU, {
                                        icon: "enquire",
                                        onClick: hanldeQna,
                                        children: "문의"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* IconButton */.hU, {
                                        icon: "print",
                                        onClick: handlePrint,
                                        children: "인쇄"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WishList, {
                                    isActive: !!isWishNo,
                                    wishNo: isWishNo,
                                    diviCd: "E",
                                    evCd: eventDetail.evCd,
                                    link: "/product/detailPackage?menu=".concat(menu, "&dspSid=").concat(dspSid, "&evCd=").concat(eventDetail.evCd),
                                    addConfirm: function() {
                                        return taggingClick({
                                            wishYn: "Y"
                                        });
                                    },
                                    removeConfirm: function() {
                                        return taggingClick({
                                            wishYn: "N"
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* IconButton */.hU, {
                                        icon: "share",
                                        onClick: handleShare,
                                        children: "공유"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* HeaderWrap */.I7, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* Title */.Dx, {
                            children: eventDetail.evNm
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* SummaryWrap */.Xg, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                            children: "출발"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                            children: (0,eventUtil/* departureStart */.jn)(eventDetail)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                            children: "성인"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                            children: [
                                                ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(price === null || price === void 0 ? void 0 : price.adult),
                                                " 원"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !usePrintView && /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* SlideWrap */.xd, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_slide/* GuideSlide */.Zj, {
                        perView: 3,
                        spaceBetween: 15,
                        children: [
                            goodsVideo === null || goodsVideo === void 0 ? void 0 : goodsVideo.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slide/* GuideSlideImg */.BN, {
                                        types: "movie",
                                        onClick: handleGoodsImageVideo,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Noimage/* Noimage */.T, {
                                            width: "100%",
                                            height: "271px",
                                            src: item.vimeoThum1,
                                            alt: item.vimeoNote
                                        })
                                    })
                                }, index);
                            }),
                            goodsImage.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slide/* GuideSlideImg */.BN, {
                                        onClick: handleGoodsImageVideo,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Noimage/* Noimage */.T, {
                                            width: "100%",
                                            height: "271px",
                                            src: item.imageThum3,
                                            alt: item.imageNote
                                        })
                                    })
                                }, index);
                            })
                        ]
                    })
                }),
                eventDetail.noTosYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* OptionBox */.Zq, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "모든 경비가 포함된 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "NO쇼핑/NO옵션/NO팁"
                            }),
                            " 상품입니다."
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconList, {
                    eventDetail: eventDetail
                }),
                (goodsDetail === null || goodsDetail === void 0 ? void 0 : goodsDetail.goodTravelYn) === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* CertifiedBox */.U0, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* CertifiedBanner */.Pi, {
                            bgColor: "#fbf4e0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "해당 상품은 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "우수여행상품으로 인증된 상품"
                                    }),
                                    "입니다."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* CertifiedContent */.w2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "우수여행상품이란 소비자에게 여행상품의 선택기준을 마련하고, 여행상품의 국제 경쟁력 제고를 위하여 한국여행업협회가 주관하고 문화체육관광부가 후원하여 인증한 상품입니다."
                            })
                        })
                    ]
                }),
                eventDetail.goodsTp === "K" && eventDetail.trTp === null && /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* CertifiedBox */.U0, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* CertifiedBanner */.Pi, {
                            noIcon: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "해당 상품은 여행지까지의 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "교통편(항공,선박 등)이 불포함 된 상품"
                                    }),
                                    "입니다."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* CertifiedContent */.w2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "숙박+현지투어(차량포함)+식사만 포함된 상품입니다. 여행지까지의 교통편은 개별 진행 부탁드리며, 도움이 필요하실 경우 노랑풍선으로 문의바랍니다."
                            })
                        })
                    ]
                }),
                eventDetail.webInsolConfYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(itinerary/* CertifiedBox */.U0, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* CertifiedBanner */.Pi, {
                            noIcon: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "해당 상품은 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "인솔자가 동행하는 상품"
                                    }),
                                    "입니다."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(itinerary/* CertifiedContent */.w2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "인솔자 동행하는 상품은 상품가에 인솔자 경비(가이드, 기사 경비 외)가 모두 포함되어 있습니다."
                            })
                        })
                    ]
                }),
                reviewSummary && reviewData && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewSummary, {
                    goodsCd: eventDetail.goodsCd,
                    reviewSummary: reviewSummary,
                    reviewData: reviewData
                })
            ]
        })
    });
};
var DetailHeader = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailHeader Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailHeaderComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var desktop_DetailHeader = (DetailHeader);


/***/ }),

/***/ 1560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ ReviewThumbnail; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_common_useOverlay__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91864);
/* harmony import */ var _COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17550);
/* harmony import */ var _COMPONENTS_common_modal_alert_Desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64024);
/* harmony import */ var _COMPONENTS_product_common_popup_desktop_ReviewListPopup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55084);
/* harmony import */ var _COMPONENTS_product_common_popup_desktop_ReviewPopup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87123);
/* harmony import */ var _COMPONENTS_product_common_popup_desktop_ReportPopup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87947);
/* harmony import */ var _COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67341);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9873);
/* harmony import */ var _FRAMEWORK_ui_desktop_flag__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34869);
/* harmony import */ var _FRAMEWORK_ui_desktop_input__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(58127);
/* harmony import */ var _FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31267);
/* harmony import */ var _FRAMEWORK_ui_desktop_list__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73255);
/* harmony import */ var _FRAMEWORK_ui_desktop_select__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64249);
/* harmony import */ var _FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(81499);
/* harmony import */ var _QUERIES_account_useSigninUser__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5142);
/* harmony import */ var _QUERIES_portal_usePortalCode__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(95134);
/* harmony import */ var _QUERIES_portal_useReview__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(3889);
/* harmony import */ var _QUERIES_portal_useReviewAI__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(50297);
/* harmony import */ var _QUERIES_portal_useReviewLike__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(81258);
/* harmony import */ var _QUERIES_portal_useReviewLikeRecommender__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26163);
/* harmony import */ var _QUERIES_portal_useReviewSummary__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(56088);
/* harmony import */ var _QUERIES_support_useReviewPictures__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(64380);
/* harmony import */ var _yb_ui_desktop_common_Noimage__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(78860);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(67294);
































var REVIEW_COUNT = 10; // 페이지당 보여줄 갯수
var GALLERY_MAX = 7; // 사진&동영상 최대 갯수
var KEYWORD_MAX = 5; // 키워드 최대 갯수
var reviewSummaryDefault = {
    reviewCnt: 0,
    scoreAvg: 0,
    companion: "",
    companionNm: "",
    companionAttr1: "",
    companionAttr2: "",
    keywordList: []
};
/** ```
 * 리뷰 썸네일
 * parameter
 *   `AttachType` 첨부파일 타입
 * return
 *  `<img />` 썸네일 이미지
 */ var ReviewThumbnail = function(attach) {
    var ref;
    var sevSaveDirNm = attach.sevSaveDirNm, sevSaveFileNm = attach.sevSaveFileNm, vimeoEndPoint = attach.vimeoEndPoint, _width = attach.width, width = _width === void 0 ? "" : _width, _height = attach.height, height = _height === void 0 ? "" : _height;
    // 이미지 리턴
    var imageUrl = sevSaveDirNm && sevSaveFileNm ? "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_8__/* ["default"].ENV_SCDN_URL */ .Z.ENV_SCDN_URL).concat(sevSaveDirNm, "/").concat(sevSaveFileNm) : null;
    var vimeoId = (vimeoEndPoint === null || vimeoEndPoint === void 0 ? void 0 : vimeoEndPoint.split("/")[2]) || null;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_25__.useState)(null), vimeoUrl = ref1[0], setVimeoUrl = ref1[1];
    var reviewPictruesFetch = (0,_QUERIES_support_useReviewPictures__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .ZP)(vimeoId, {
        enabled: !!vimeoId
    });
    var reviewPictrues = ((ref = reviewPictruesFetch.data) === null || ref === void 0 ? void 0 : ref.body) || null;
    (0,react__WEBPACK_IMPORTED_MODULE_25__.useEffect)(function() {
        var ref, ref1;
        if (reviewPictrues) setVimeoUrl(reviewPictrues === null || reviewPictrues === void 0 ? void 0 : (ref = reviewPictrues.sizes) === null || ref === void 0 ? void 0 : (ref1 = ref[2]) === null || ref1 === void 0 ? void 0 : ref1.link_with_play_button);
    }, [
        reviewPictrues
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yb_ui_desktop_common_Noimage__WEBPACK_IMPORTED_MODULE_26__/* .Noimage */ .T, {
        src: imageUrl || vimeoUrl,
        width: width,
        height: height
    });
};
var ReviewComponent = function(param) {
    var evCd = param.evCd;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var goodsCd = evCd.split("-")[0];
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)((0,_hooks_common_useOverlay__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), 1), open = ref7[0];
    // 유저 정보 조회
    var signin = (0,_QUERIES_account_useSigninUser__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP)();
    var signinCode = ((ref = signin.data) === null || ref === void 0 ? void 0 : ref.code) || "9999";
    // 리뷰 리스트 조회
    var reviewDataFetch = (0,_QUERIES_portal_useReview__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(goodsCd);
    var reviewData = ((ref1 = reviewDataFetch.data) === null || ref1 === void 0 ? void 0 : ref1.body) || null;
    // 리뷰 데이터 정제
    var originReview = (0,react__WEBPACK_IMPORTED_MODULE_25__.useMemo)(function() {
        if (!reviewData) return [];
        var reviewList = reviewData.reviewList, attach = reviewData.attachList;
        return reviewList.reduce(function(acc, cur) {
            var attachList = attach.filter(function(v) {
                return v.reviewId === cur.reviewId;
            });
            var item = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)({}, cur), {
                attachList: attachList
            });
            acc.push(item);
            return acc;
        }, []);
    }, [
        reviewData
    ]);
    // 리뷰 좋아요 조회 (로그인 유저)
    var reviewLikeRecommenderFetch = (0,_QUERIES_portal_useReviewLikeRecommender__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP)(goodsCd, {
        enabled: signinCode === "0000"
    });
    var reviewLikeRecommender = ((ref2 = reviewLikeRecommenderFetch.data) === null || ref2 === void 0 ? void 0 : ref2.body) || [];
    // 리뷰 서머리 조회
    var reviewSummaryFetch = (0,_QUERIES_portal_useReviewSummary__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP)(goodsCd);
    var reviewSummary = ((ref3 = reviewSummaryFetch.data) === null || ref3 === void 0 ? void 0 : ref3.body) || reviewSummaryDefault;
    // 리뷰 AI 조회
    var reviewAIFetch = (0,_QUERIES_portal_useReviewAI__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)(goodsCd);
    var reviewAI = (ref4 = reviewAIFetch.data) === null || ref4 === void 0 ? void 0 : ref4.body;
    // 공통코드 조회 (동행인 코드)
    var companionCodeFetch = (0,_QUERIES_portal_usePortalCode__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP)("REVIEW_COMPANION");
    var companionCode = ((ref5 = companionCodeFetch.data) === null || ref5 === void 0 ? void 0 : ref5.body) || [];
    // 공통코드 조회 (나이 코드)
    var ageCodeFetch = (0,_QUERIES_portal_usePortalCode__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP)("REVIEW_AGE");
    var ageCode = ((ref6 = ageCodeFetch.data) === null || ref6 === void 0 ? void 0 : ref6.body) || [];
    // AI 여행 분석 툴팁
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_25__.useState)(false), showTooltip = ref8[0], setShowTooltip = ref8[1];
    var handleMouseEnter = function() {
        return setShowTooltip(true);
    };
    var handleMouseLeave = function() {
        return setShowTooltip(false);
    };
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_25__.useState)(1), page = ref9[0], setPage = ref9[1];
    // 리뷰 SORT
    var rating = [
        {
            text: "별점순",
            value: "score",
            asc: false
        },
        {
            text: "최신순",
            value: "reviewDt",
            asc: false
        },
        {
            text: "추천순",
            value: "likeCnt",
            asc: false
        }, 
    ];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_25__.useState)(rating[0]), selectedRate = ref10[0], setSelectedRate = ref10[1];
    // 사진 동영상 리뷰만 모아보기 체크박스
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_25__.useState)(false), isAttach = ref11[0], setIsAttach = ref11[1];
    // 필터 : 동행인 셀렉트 박스
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_25__.useState)(false), showCompanion = ref12[0], setShowCompanion = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_25__.useState)({
        key: "ALL",
        text: "동행인 전체"
    }), currentCompanion = ref13[0], setCurrentCompanion = ref13[1];
    // 필터 : 연령대 셀렉트 박스
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_25__.useState)(false), showAge = ref14[0], setShowAge = ref14[1];
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_25__.useState)({
        key: "ALL",
        text: "연령대 전체"
    }), currentAge = ref15[0], setCurrentAge = ref15[1];
    var handleCompanion = function(e) {
        var text = e.target.innerText;
        var key = e.target.getAttribute("value");
        setCurrentCompanion({
            key: key,
            text: text
        });
        setShowCompanion(function(show) {
            return !show;
        });
    };
    var handleAge = function(e) {
        var text = e.target.innerText;
        var key = e.target.getAttribute("value");
        setCurrentAge({
            key: key,
            text: text
        });
        setShowAge(function(show) {
            return !show;
        });
    };
    // 동행인, 연령대 셀렉트 외 영역 클릭시 닫기
    (0,react__WEBPACK_IMPORTED_MODULE_25__.useEffect)(function() {
        var event = function(e) {
            if (document.body.contains(e.target)) {
                !e.target.closest("#".concat(CSS.escape("__companion"))) && setShowCompanion(false);
                !e.target.closest("#".concat(CSS.escape("__age"))) && setShowAge(false);
            }
        };
        setTimeout(function() {
            return window.addEventListener("click", event);
        });
        return function() {
            window.removeEventListener("click", event);
        };
    }, [
        showCompanion,
        showAge
    ]);
    /** 키워드 리스트 */ var keywords = (0,react__WEBPACK_IMPORTED_MODULE_25__.useMemo)(function() {
        if (!reviewSummary || !reviewSummary.keywordList) return [];
        var result = reviewSummary.keywordList || [];
        // keywordCnt 기준으로 내림차순 정렬
        result.sort(function(a, b) {
            return b.keywordCnt - a.keywordCnt;
        });
        return result.slice(0, KEYWORD_MAX);
    }, [
        reviewSummary
    ]);
    var ref16;
    /** 사진&동영상 리스트 */ var galleries = (0,react__WEBPACK_IMPORTED_MODULE_25__.useMemo)(function() {
        return (ref16 = originReview === null || originReview === void 0 ? void 0 : originReview.filter(function(v) {
            var ref;
            return ((ref = v.attachList) === null || ref === void 0 ? void 0 : ref.length) > 0;
        })) !== null && ref16 !== void 0 ? ref16 : [];
    }, [
        originReview
    ]);
    /** 필터된 리뷰 리스트 */ var firteredReviews = (0,react__WEBPACK_IMPORTED_MODULE_25__.useMemo)(function() {
        if (page !== 1) setPage(1); // 필터링 시 페이지 초기화
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z)(originReview).filter(function(v) {
            var ref;
            return (currentCompanion.key === "ALL" || v.companion === currentCompanion.key) && (currentAge.key === "ALL" || v.age === currentAge.key) && (!isAttach || ((ref = v.attachList) === null || ref === void 0 ? void 0 : ref.length) > 0);
        });
    }, [
        currentCompanion,
        currentAge,
        isAttach
    ]);
    /** 리뷰 리스트 */ var reviews = (0,react__WEBPACK_IMPORTED_MODULE_25__.useMemo)(function() {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z)(originReview).filter(function(v) {
            var ref;
            return (currentCompanion.key === "ALL" || v.companion === currentCompanion.key) && (currentAge.key === "ALL" || v.age === currentAge.key) && (!isAttach || ((ref = v.attachList) === null || ref === void 0 ? void 0 : ref.length) > 0);
        }).sort(function(a, b) {
            if (a[selectedRate.value] < b[selectedRate.value]) return selectedRate.asc ? -1 : 1;
            if (a[selectedRate.value] > b[selectedRate.value]) return selectedRate.asc ? 1 : -1;
            return dayjs__WEBPACK_IMPORTED_MODULE_24___default()(b.reviewDt).valueOf() - dayjs__WEBPACK_IMPORTED_MODULE_24___default()(a.reviewDt).valueOf(); // 최신순 정렬
        }).slice(0, page * REVIEW_COUNT);
    }, [
        originReview,
        currentCompanion,
        currentAge,
        selectedRate,
        isAttach,
        page
    ]);
    // 텍스트 더보기 버튼
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_25__.useState)([]), expandedReviewIds = ref17[0], setExpandedReviewIds = ref17[1];
    var ref18 = (0,react__WEBPACK_IMPORTED_MODULE_25__.useState)({}), showMoreButton = ref18[0], setShowMoreButton = ref18[1];
    var textRefs = (0,react__WEBPACK_IMPORTED_MODULE_25__.useRef)({});
    (0,react__WEBPACK_IMPORTED_MODULE_25__.useEffect)(function() {
        originReview.forEach(function(review) {
            var textElement = textRefs.current[review.reviewId];
            if (textElement) {
                var lineHeight = parseInt(getComputedStyle(textElement).lineHeight, 10);
                var maxHeight = lineHeight * 3; // 3줄 높이 계산
                if (textElement.scrollHeight > maxHeight) {
                    setShowMoreButton(function(prev) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)({}, review.reviewId, true));
                    });
                } else {
                    setShowMoreButton(function(prev) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)({}, review.reviewId, false));
                    });
                }
            }
        });
    }, [
        currentCompanion,
        currentAge,
        selectedRate,
        isAttach,
        page
    ]);
    // 더보기 접기 버튼
    var toggleExpand = function(id) {
        setExpandedReviewIds(function(prev) {
            return prev.includes(id) ? prev.filter(function(reviewId) {
                return reviewId !== id;
            }) : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z)(prev).concat([
                id
            ]);
        });
    };
    // 상세 팝업
    var ref19 = (0,react__WEBPACK_IMPORTED_MODULE_25__.useState)(null), detailReviewId = ref19[0], setDetailReviewId = ref19[1];
    var ref20 = (0,react__WEBPACK_IMPORTED_MODULE_25__.useState)(null), optionAttach = ref20[0], setOptionAttach = ref20[1]; // 선택한 이미지 default
    var handleReviewOpen = function(reviewId) {
        var attach = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        setDetailReviewId(reviewId);
        setOptionAttach(attach);
    };
    var handleReviewClose = function() {
        return setDetailReviewId(null);
    };
    // 리스트 팝업
    var ref21 = (0,react__WEBPACK_IMPORTED_MODULE_25__.useState)(false), isListPopup = ref21[0], setIsListPopup = ref21[1];
    var handleReviewListOpen = function() {
        return setIsListPopup(true);
    };
    var handleReviewListClose = function() {
        return setIsListPopup(false);
    };
    // 추천하기(좋아요) 버튼
    var handleLike = function(reviewId) {
        if (signinCode === "0000") {
            (0,_QUERIES_portal_useReviewLike__WEBPACK_IMPORTED_MODULE_20__/* .reviewLikeAsync */ .oM)({
                goodsCd: goodsCd,
                reviewId: reviewId.toString()
            }).then(function(result) {
                if (result.data.code === "0000") {
                    reviewDataFetch.refetch();
                    reviewLikeRecommenderFetch.refetch();
                }
            });
        } else {
            open(function(prop) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_modal_alert_Desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)({}, prop), {
                    alertType: "confirm",
                    text: "로그인 후 이용하실 수 있습니다. <br/>로그인하시겠습니까?",
                    resolve: function(value) {
                        return !!value && LoginUtil.login();
                    }
                }));
            });
        }
    };
    // 신고하기 버튼
    var handleReport = function(review) {
        var reportYn = review.reportYn, reviewId = review.reviewId;
        if (reportYn === "Y") {
            open(function(prop) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_modal_alert_Desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)({}, prop), {
                    text: "신고사유 검토중인 게시물입니다.<br/>빠른 시일 내에 처리하겠습니다."
                }));
            });
            return;
        }
        if (signinCode === "0000") {
            open(function(overlay) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_product_common_popup_desktop_ReportPopup__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)({}, overlay), {
                    reportId: reviewId,
                    reportType: "REVIEW"
                }));
            });
        } else {
            open(function(prop) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_modal_alert_Desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)({}, prop), {
                    alertType: "confirm",
                    text: "로그인 후 이용하실 수 있습니다. <br/>로그인하시겠습니까?",
                    resolve: function(value) {
                        return !!value && LoginUtil.login();
                    }
                }));
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .SubTitleWrap */ .Ar, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_15__/* .SubTitle */ .DK, {
                    children: "고객리뷰 및 여행후기"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .CategoryTitle */ .gI, {
                $line: true,
                children: "고객리뷰(".concat(reviewSummary.reviewCnt, ")")
            }),
            originReview.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_12__/* .Flex */ .kC, {
                                direction: "column",
                                align: "center",
                                gap: "20",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .Rating */ .iG, {
                                        "aria-label": "평점 ".concat(reviewSummary.scoreAvg, "점"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: reviewSummary.scoreAvg
                                            }),
                                            " / ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                                children: "5"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .CustomerReview */ .n8, {
                                        children: [
                                            "총 ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                                children: reviewSummary.reviewCnt
                                            }),
                                            "명의 고객님이 이 여행을 이렇게 평가해주셨어요."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .TripLabel */ .cB, {
                                        children: reviewSummary.companionAttr1
                                    })
                                ]
                            }),
                            reviewSummary.reviewCnt >= 10 && reviewAI && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .Paragraph */ .nv, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .SubHeadingWrap */ .p$, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .CategoryTitle */ .gI, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: "AI"
                                                        }),
                                                        " 여행 분석"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .ToolTipBtn */ .iH, {
                                                    onMouseEnter: handleMouseEnter,
                                                    onMouseLeave: handleMouseLeave,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: "AI 리뷰 요약"
                                                        }),
                                                        showTooltip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .ToolTip */ .eE, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "AI 리뷰 요약이란?"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            children: "- 많은 양의 고객 리뷰를 AI가 요점만 요약해 드립니다."
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            children: "- 요약 내용은 주기적으로 업데이트됩니다."
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .Percent */ .gG, {
                                                    children: [
                                                        "긍정 평가 ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                                            children: reviewAI.emotion
                                                        }),
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .Summary */ .ER, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                                    children: "이 여행의 리뷰를 요약하면,"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: reviewAI.summary
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .Tag */ .Xn, {
                                                    children: reviewAI.keyword.split(" ").slice(0, 5).map(function(tag, index) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: tag.replace("#", "")
                                                        }, index);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            keywords.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .Paragraph */ .nv, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .CategoryTitle */ .gI, {
                                        children: "이 여행은 이런 점이 좋아요"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .Highlights */ .xK, {
                                        children: keywords.map(function(item, index) {
                                            var keyword = item.keyword, keywordCnt = item.keywordCnt;
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .HighlightItem */ .Hl, {
                                                children: [
                                                    keyword,
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: keywordCnt
                                                    }),
                                                    "명"
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    galleries.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .CategoryTitle */ .gI, {
                                children: "사진&동영상"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .Gallery */ .ri, {
                                children: galleries.slice(0, GALLERY_MAX).map(function(gallery, galleryIndex) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .GalleryItem */ .Lm, {
                                        $isList: galleryIndex + 1 === GALLERY_MAX,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "#",
                                            onClick: function(e) {
                                                e.preventDefault();
                                                handleReviewListOpen();
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReviewThumbnail, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)({}, gallery.attachList[0]))
                                        })
                                    }, gallery.reviewId);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .ReviewFilter */ .hc, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_12__/* .Flex */ .kC, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_12__/* .Flex */ .kC, {
                                        gap: "10",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .SelectWrap */ .vA, {
                                                id: "__companion",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_select__WEBPACK_IMPORTED_MODULE_14__/* .SelectBox */ .jL, {
                                                        onClick: function() {
                                                            return setShowCompanion(!showCompanion);
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_select__WEBPACK_IMPORTED_MODULE_14__/* .SelectLabel */ .n5, {
                                                            children: currentCompanion.text
                                                        })
                                                    }),
                                                    showCompanion && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FRAMEWORK_ui_desktop_select__WEBPACK_IMPORTED_MODULE_14__/* .SelectOptions */ .PN, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                onClick: handleCompanion,
                                                                value: "ALL",
                                                                children: "동행인 전체"
                                                            }),
                                                            companionCode.map(function(companion) {
                                                                var commCdId = companion.commCdId, commCdNm = companion.commCdNm;
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    onClick: handleCompanion,
                                                                    value: commCdId,
                                                                    children: commCdNm
                                                                }, commCdId);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .SelectWrap */ .vA, {
                                                id: "__age",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_select__WEBPACK_IMPORTED_MODULE_14__/* .SelectBox */ .jL, {
                                                        onClick: function() {
                                                            return setShowAge(!showAge);
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_select__WEBPACK_IMPORTED_MODULE_14__/* .SelectLabel */ .n5, {
                                                            children: currentAge.text
                                                        })
                                                    }),
                                                    showAge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FRAMEWORK_ui_desktop_select__WEBPACK_IMPORTED_MODULE_14__/* .SelectOptions */ .PN, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                onClick: handleAge,
                                                                value: "ALL",
                                                                children: "연령대 전체"
                                                            }),
                                                            ageCode.map(function(age) {
                                                                var commCdId = age.commCdId, commCdNm = age.commCdNm;
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    onClick: handleAge,
                                                                    value: commCdId,
                                                                    children: commCdNm
                                                                }, commCdId);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .CheckboxWrap */ .ot, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_input__WEBPACK_IMPORTED_MODULE_11__/* .Checkbox */ .XZ, {
                                                id: "check-attach",
                                                onChange: function() {
                                                    return setIsAttach(!isAttach);
                                                },
                                                checked: isAttach
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                htmlFor: "check-attach",
                                                children: "사진&동영상 리뷰만 모아보기"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_list__WEBPACK_IMPORTED_MODULE_13__/* .StackList */ .fe, {
                                cursor: "pointer",
                                children: rating.map(function(rate) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_list__WEBPACK_IMPORTED_MODULE_13__/* .StackListItem */ .jS, {
                                        onClick: function() {
                                            return setSelectedRate(rate);
                                        },
                                        isActive: selectedRate.value === rate.value,
                                        children: rate.text
                                    }, rate.value);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                children: reviews.slice(0, page * REVIEW_COUNT).map(function(review) {
                    var score = review.score, custNm = review.custNm, ageNm = review.ageNm, companionNm = review.companionNm, reviewDt = review.reviewDt, keywords = review.keywords, attachList = review.attachList, detail = review.detail;
                    var likeCnt = review.likeCnt, reviewId = review.reviewId;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .ReviewListItem */ .nS, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .ReviewTopBar */ .lv, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .ScoreWrap */ .lW, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_flag__WEBPACK_IMPORTED_MODULE_10__/* .StarScore */ .xo, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    style: {
                                                        width: "calc(".concat(Math.round(score), " * 20%)")
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                                children: Math.round(score)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .ReviewerProfile */ .Yg, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .UserName */ .vx, {
                                                children: [
                                                    custNm !== null && custNm !== void 0 ? custNm : " - ",
                                                    "님"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .ProfileDetails */ .og, {
                                                children: [
                                                    ageNm && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: ageNm
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: companionNm
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .Date */ .Ej, {
                                        dateTime: dayjs__WEBPACK_IMPORTED_MODULE_24___default()(reviewDt).format("YYYY.MM.DD"),
                                        children: dayjs__WEBPACK_IMPORTED_MODULE_24___default()(reviewDt).format("YYYY.MM.DD")
                                    })
                                ]
                            }),
                            keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .Highlights */ .xK, {
                                children: keywords.split(",").map(function(keyword, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_25__.Fragment, {
                                        children: keyword && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .HighlightItem */ .Hl, {
                                            children: keyword
                                        })
                                    }, index);
                                })
                            }),
                            attachList && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .ReviewGallery */ .Ck, {
                                children: attachList.map(function(attach, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .ReviewGalleryItem */ .Nt, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "#",
                                            onClick: function(e) {
                                                e.preventDefault();
                                                handleReviewOpen(reviewId, attach);
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReviewThumbnail, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)({}, attach))
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .ReviewText */ .lb, {
                                ref: function(el) {
                                    return textRefs.current[reviewId] = el;
                                },
                                isShow: expandedReviewIds.includes(reviewId),
                                dangerouslySetInnerHTML: {
                                    __html: detail.replace(/\n/g, "<br />")
                                }
                            }),
                            showMoreButton[reviewId] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_9__/* .TextMoreButton */ .nU, {
                                onClick: function() {
                                    return toggleExpand(reviewId);
                                },
                                isShow: expandedReviewIds.includes(reviewId)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .FeedbackControls */ .nM, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .RecommendBtnWrap */ .FR, {
                                        onClick: function() {
                                            return handleLike(reviewId);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .RecommendBtnIcon */ .aw, {
                                                $isActive: !!reviewLikeRecommender.find(function(v) {
                                                    return v.reviewId === reviewId;
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .RecommendBtn */ .Vp, {
                                                children: "추천"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .LikeCount */ .oU, {
                                                children: likeCnt
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .ReportBtn */ .uQ, {
                                        onClick: function() {
                                            return handleReport(review);
                                        },
                                        children: "신고하기"
                                    })
                                ]
                            })
                        ]
                    }, reviewId);
                })
            }),
            page * REVIEW_COUNT < firteredReviews.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .LoadMoreBtn */ .CF, {
                onClick: function() {
                    return setPage(page + 1);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("em", {
                    children: [
                        "더보기(",
                        page * REVIEW_COUNT,
                        "/",
                        firteredReviews.length,
                        ")"
                    ]
                })
            }),
            originReview.length === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .WriteRequest */ .$0, {
                children: "아직 작성된 리뷰가 없습니다."
            }),
            originReview.length !== 0 && reviews.length === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_reviews__WEBPACK_IMPORTED_MODULE_7__/* .WriteRequest */ .$0, {
                children: [
                    "조건에 맞는 리뷰가 없습니다.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    " 필터를 변경하여 다른 조건으로 검색해보세요."
                ]
            }),
            detailReviewId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_product_common_popup_desktop_ReviewPopup__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                optionAttach: optionAttach,
                reviewId: detailReviewId,
                goodsCd: goodsCd,
                close: handleReviewClose,
                listOpen: handleReviewListOpen
            }),
            isListPopup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_product_common_popup_desktop_ReviewListPopup__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                goodsCd: goodsCd,
                close: handleReviewListClose,
                reviewOpen: handleReviewOpen
            })
        ]
    });
};
var Review = function(param) {
    var evCd = param.evCd;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReviewComponent, {
            evCd: evCd
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Review);


/***/ }),

/***/ 74761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DK": function() { return /* binding */ SubTitle; },
/* harmony export */   "DL": function() { return /* binding */ ExpensesTable; },
/* harmony export */   "DY": function() { return /* binding */ BulletList; },
/* harmony export */   "XU": function() { return /* binding */ InfoText; },
/* harmony export */   "Z7": function() { return /* binding */ BtnArea; },
/* harmony export */   "aX": function() { return /* binding */ LocationText; },
/* harmony export */   "ls": function() { return /* binding */ EditorWrap; },
/* harmony export */   "pY": function() { return /* binding */ TableInfoText; },
/* harmony export */   "rL": function() { return /* binding */ RadioList; },
/* harmony export */   "si": function() { return /* binding */ ExpensesTd; },
/* harmony export */   "tc": function() { return /* binding */ ProductTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93391);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	justify-content: flex-end;\n	margin-bottom: 10px;\n	@media print {\n		button {\n			display: none;\n		}\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	align-items: baseline;\n	justify-content: space-between;\n	margin-top: 40px;\n	margin-bottom: 20px;\n	line-height: 1;\n	font-size: var(--medium-size);\n	color: var(--emp-color);\n	> p {\n		margin-bottom: 0;\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	border-top: 1px solid var(--emp-color);\n	th {\n		height: 60px;\n		padding: 0 20px;\n		border-bottom: 1px solid var(--line-color);\n		background: var(--disabled-color);\n		color: var(--emp-color);\n		text-align: center;\n		vertical-align: middle;\n		&:not(:last-child) {\n			border-right: 1px solid var(--line-color);\n		}\n	}\n	tbody {\n		width: 100%;\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	height: inherit;\n	padding: 7px 0;\n	padding-right: ",
        ";\n	border-right: 1px solid var(--line-color);\n	border-bottom: ",
        ";\n	font-size: var(--default-size);\n	text-align: ",
        ";\n	vertical-align: middle;\n	color: var(--default-color);\n	em {\n		font-size: var(--medium-size);\n	}\n	&:last-child {\n		border-right: 0;\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	font-size: var(--medium-size);\n	font-weight: normal;\n	color: var(--emp-color);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	> li + li {\n		margin-left: 20px;\n	}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin-top: 10px;\n	> li {\n		line-height: 24px;\n		font-size: var(--default-size);\n		&::before {\n			top: 10px;\n		}\n	}\n	@media print {\n		li {\n			font-size: var(--medium-size);\n		}\n	}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin-bottom: 20px;\n	line-height: 1;\n	font-size: var(--basic-size);\n	text-align: right;\n	em {\n		color: var(--blue-color);\n	}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	font-size: var(--small-size);\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding: 15px;\n	text-align: left;\n\n	@media print {\n		padding: 5px;\n	}\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin-top: 10px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var BtnArea = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3422c5e2-0"
})(_templateObject());
var SubTitle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-3422c5e2-1"
})(_templateObject1());
var ExpensesTable = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    componentId: "sc-3422c5e2-2"
})(_templateObject2());
var ExpensesTd = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].td.withConfig */ .ZP.td.withConfig({
    componentId: "sc-3422c5e2-3"
})(_templateObject3(), function(props) {
    return props.align ? "10px" : "0";
}, function(props) {
    return props.line ? "1px solid var(--line-color)" : "0";
}, function(props) {
    return props.align ? props.align : "center";
});
var ProductTitle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].strong.withConfig */ .ZP.strong.withConfig({
    componentId: "sc-3422c5e2-4"
})(_templateObject4());
var RadioList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-3422c5e2-5"
})(_templateObject5());
var BulletList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-3422c5e2-6"
})(_templateObject6());
var TableInfoText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-3422c5e2-7"
})(_templateObject7());
var InfoText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-3422c5e2-8"
})(_templateObject8());
var LocationText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-3422c5e2-9"
})(_templateObject9());
var EditorWrap = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3422c5e2-10"
})(_templateObject10());



/***/ }),

/***/ 5955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ SlideButton; },
/* harmony export */   "Ej": function() { return /* binding */ Date; },
/* harmony export */   "Eq": function() { return /* binding */ Wrap; },
/* harmony export */   "FR": function() { return /* binding */ RecommendBtnWrap; },
/* harmony export */   "GI": function() { return /* binding */ Popup; },
/* harmony export */   "Hl": function() { return /* binding */ HighlightItem; },
/* harmony export */   "Lm": function() { return /* binding */ GalleryItem; },
/* harmony export */   "Lt": function() { return /* binding */ ReviewContent; },
/* harmony export */   "N_": function() { return /* binding */ ListLink; },
/* harmony export */   "Pd": function() { return /* binding */ DetailDate; },
/* harmony export */   "SP": function() { return /* binding */ PostMeta; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "Vp": function() { return /* binding */ RecommendBtn; },
/* harmony export */   "Yg": function() { return /* binding */ ReviewerProfile; },
/* harmony export */   "aB": function() { return /* binding */ ReviewInfo; },
/* harmony export */   "aw": function() { return /* binding */ RecommendBtnIcon; },
/* harmony export */   "h4": function() { return /* binding */ Header; },
/* harmony export */   "lW": function() { return /* binding */ ScoreWrap; },
/* harmony export */   "lb": function() { return /* binding */ ReviewText; },
/* harmony export */   "ls": function() { return /* binding */ EditorWrap; },
/* harmony export */   "lv": function() { return /* binding */ ReviewTopBar; },
/* harmony export */   "n5": function() { return /* binding */ User; },
/* harmony export */   "nI": function() { return /* binding */ ReportWrap; },
/* harmony export */   "nM": function() { return /* binding */ FeedbackControls; },
/* harmony export */   "oU": function() { return /* binding */ LikeCount; },
/* harmony export */   "og": function() { return /* binding */ ProfileDetails; },
/* harmony export */   "ol": function() { return /* binding */ PreviewList; },
/* harmony export */   "pU": function() { return /* binding */ Media; },
/* harmony export */   "ri": function() { return /* binding */ Gallery; },
/* harmony export */   "s7": function() { return /* binding */ DetailContent; },
/* harmony export */   "s8": function() { return /* binding */ PreviewItem; },
/* harmony export */   "uN": function() { return /* binding */ BestTag; },
/* harmony export */   "uQ": function() { return /* binding */ ReportBtn; },
/* harmony export */   "vx": function() { return /* binding */ UserName; },
/* harmony export */   "xK": function() { return /* binding */ Highlights; }
/* harmony export */ });
/* unused harmony export InfoText */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93391);
/* harmony import */ var _PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99653);
/* harmony import */ var _PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _PUBLIC_P_images_btn_btn_arrow_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79972);
/* harmony import */ var _PUBLIC_P_images_btn_btn_arrow_png__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_PUBLIC_P_images_btn_btn_arrow_png__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14358);
/* harmony import */ var _PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_3__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: fixed;\n	top: 0;\n	left: 0;\n	width: 100%;\n	height: 100%;\n	margin: 0px auto;\n	z-index: 101;\n	background-color: rgba(0, 0, 0, 0.6);\n	animation: fadeIn 0.3s ease forwards;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n	top: 50%;\n	left: 50%;\n	width: 990px;\n	height: 680px;\n	background: #fff;\n	transform: translate(-50%, -50%);\n	transition: visibility 0.3s ease-out;\n	box-sizing: border-box;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: space-between;\n	height: 70px;\n	margin: 0 40px;\n	border-bottom: ",
        ';\n	box-sizing: border-box;\n\n	h3 {\n		color: var(--emp-color);\n		font-size: 22px;\n		font-family: "pr-font-medium";\n		line-height: 1;\n	}\n'
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: space-between;\n	padding: 0 20px;\n	min-height: 60px;\n	border-bottom: 1px solid #222;\n\n	h4 {\n		display: flex;\n		align-items: center;\n		gap: 10px;\n		padding-right: 10px;\n		flex: 1;\n		font-size: 16px;\n		color: var(--emp-color);\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--emp-color);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	margin-left: 20px;\n\n	&::before {\n		display: inline-block;\n		width: 1px;\n		height: 11px;\n		margin-right: 20px;\n		background: var(--bl-color);\n		content: "";\n	}\n'
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	height: 610px;\n	padding: 0 23px 0 40px;\n	overflow-y: auto;\n	scrollbar-gutter: stable;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	gap: 20px;\n	padding: 0 0 40px 40px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding: 40px 20px 20px;\n	min-height: 472px;\n	border-bottom: 1px solid var(--line-color);\n	box-sizing: border-box;\n\n	img {\n		max-width: 700px;\n	}\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: end;\n	padding: 14px 20px 40px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n	padding-left: 27px;\n	font-size: var(--basic-size);\n\n	&::before {\n		position: absolute;\n		top: 2px;\n		left: 0;\n		display: inline-block;\n		width: 18px;\n		height: 18px;\n		background: url(",
        ') no-repeat 0 -287px;\n		vertical-align: middle;\n		content: "";\n	}\n'
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	background-color: transparent;\n	border-bottom: 1px solid var(--emp-color);\n	font-size: var(--basic-size);\n	font-family: "pr-font-regular";\n	color: var(--emp-color);\n	line-height: 1;\n'
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: absolute;\n	top: 50%;\n	width: 20px;\n	height: 40px;\n	background-color: transparent;\n	background-image: url(",
        ");\n	background-repeat: no-repeat;\n	transform: translateY(-50%);\n\n	",
        "\n	",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: grid;\n	grid-template-columns: repeat(7, 1fr);\n	grid-gap: 9px;\n	padding-bottom: 40px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n	display: block;\n\n	img {\n		width: 100%;\n	}\n\n	span {\n		position: absolute;\n		top: 0;\n		right: 0;\n		display: flex;\n		align-items: center;\n		justify-content: center;\n		width: 26px;\n		height: 25px;\n		color: #fff;\n		font-size: var(--basic-size);\n		background-color: rgba(0, 0, 0, 0.6);\n	}\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	width: 450px;\n	height: 570px;\n	background-color: var(--emp-color);\n	box-sizing: border-box;\n\n	> div {\n		width: 100%;\n		background-color: var(--emp-color);\n	}\n\n	img {\n		width: 100%;\n		height: 100%;\n		object-fit: contain;\n	}\n	iframe {\n		border: none;\n	}\n	.fallback_thumb {\n		background-color: #eee;\n	}\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-wrap: wrap;\n	gap: 2px;\n	width: 440px;\n	padding-bottom: 20px;\n	margin-right: 40px;\n	border-bottom: 1px solid var(--line-color);\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	position: relative;\n	height: 42px;\n	width: 42px;\n	cursor: pointer;\n	background-color: #222;\n\n	img {\n		height: 100%;\n		width: 100%;\n	}\n\n	&:after {\n		position: absolute;\n		left: 0;\n		top: 0;\n		height: 100%;\n		width: 100%;\n		background-color: rgba(255, 255, 255, 0.5);\n		content: "";\n	}\n\n	',
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: grid;\n	grid-template-columns: auto 1fr auto;\n	align-items: center;\n	gap: 20px;\n	line-height: 1;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	gap: 20px;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--emp-color);\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	span:not(:first-child) {\n		position: relative;\n		padding-left: 10px;\n		margin-left: 10px;\n\n		&:before {\n			position: absolute;\n			top: 50%;\n			left: 0;\n			display: inline-block;\n			width: 3px;\n			height: 3px;\n			background-color: var(--line-color);\n			transform: translateY(-50%);\n			content: "";\n		}\n	}\n'
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	em {\n		margin-left: 10px;\n		font-size: 16px;\n		font-family: "pr-font-bold";\n		color: var(--emp-color);\n	}\n'
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	font-size: var(--basic-size);\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-wrap: wrap;\n	gap: 10px;\n	margin-top: 18px;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	align-items: center;\n	height: 28px;\n	padding: 0 20px;\n	background-color: var(--disabled-color);\n	border-radius: 4px;\n	font-size: var(--basic-size);\n	box-sizing: border-box;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin: 15px 0 36px;\n	letter-spacing: 0.015em;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: column;\n	height: 100%;\n	padding-right: 25px;\n	margin-top: 20px;\n	overflow-y: auto;\n	scrollbar-gutter: stable;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: column;\n	flex: 1;\n	height: 570px;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	justify-content: space-between;\n	margin-top: auto;\n	line-height: 1;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n	display: flex;\n	align-items: center;\n	padding-left: 30px;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	position: relative;\n	display: block;\n	margin-right: 10px;\n	background-color: #fff;\n	font-family: "pr-font-regular";\n	font-size: var(--basic-size);\n'
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: absolute;\n	top: -2px;\n	left: 0;\n	display: inline-block;\n	width: 21px;\n	height: 18px;\n	background: transparent url(",
        ") 0 -18px / 93px 40px;\n	cursor: pointer;\n\n	",
        "\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	font-size: var(--basic-size);\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	position: relative;\n	display: block;\n	padding-right: 13px;\n	font-size: var(--basic-size);\n	line-height: 1;\n\n	&:after {\n		position: absolute;\n		right: 1px;\n		bottom: 0;\n		width: 6px;\n		height: 6px;\n		border-top: 1px solid var(--default-color);\n		border-left: 1px solid var(--default-color);\n		transform: translate(-50%, -50%) rotate(135deg);\n		content: "";\n	}\n'
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: inline-block;\n	flex: 0 0 auto;\n	height: 20px;\n	line-height: 20px;\n	padding: 0 8px;\n	border: 1px solid var(--red-color);\n	border-radius: 10px;\n	background-color: #fff;\n	font-size: var(--small-size);\n	color: var(--red-color);\n	text-align: center;\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}




var Wrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-0"
})(_templateObject());
var Popup = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-1"
})(_templateObject1());
var Header = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-2"
})(_templateObject2(), function(param) {
    var _line = param.line, line = _line === void 0 ? true : _line;
    return line ? "1px solid #222" : "none";
});
var PostMeta = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-3"
})(_templateObject3());
var User = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-dd63561a-4"
})(_templateObject4());
var Date = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-dd63561a-5"
})(_templateObject5());
var Content = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-6"
})(_templateObject6());
var DetailContent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-7"
})(_templateObject7());
var EditorWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-8"
})(_templateObject8());
var ReportWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-9"
})(_templateObject9());
var InfoText = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-dd63561a-10"
})(_templateObject10(), (_PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1___default()));
var ReportBtn = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-dd63561a-11"
})(_templateObject11());
var SlideButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-dd63561a-12"
})(_templateObject12(), (_PUBLIC_P_images_btn_btn_arrow_png__WEBPACK_IMPORTED_MODULE_2___default()), function(props) {
    return props.direction === "next" && "\n			right: -40px;\n			background-position: -74px 0;\n\n			&:hover {\n				background-position: -24px 0;\n			}\n\n		";
}, function(props) {
    return props.direction === "prev" && "\n			left: -40px;\n			background-position: -50px 0;\n\n			&:hover {\n				background-position: 0 0;\n			}\n		";
});
var Gallery = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-dd63561a-13"
})(_templateObject13());
var GalleryItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-dd63561a-14"
})(_templateObject14());
var Media = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-15"
})(_templateObject15());
var PreviewList = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-dd63561a-16"
})(_templateObject16());
var PreviewItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-dd63561a-17"
})(_templateObject17(), function(props) {
    return props.$isSelected && "\n		&:after {\n			display: none;\n		}\n	";
});
var ReviewTopBar = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-18"
})(_templateObject18());
var ReviewerProfile = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-19"
})(_templateObject19());
var UserName = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-dd63561a-20"
})(_templateObject20());
var ProfileDetails = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-21"
})(_templateObject21());
var ScoreWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-22"
})(_templateObject22());
var DetailDate = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].time.withConfig */ .ZP.time.withConfig({
    componentId: "sc-dd63561a-23"
})(_templateObject23());
var Highlights = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-dd63561a-24"
})(_templateObject24());
var HighlightItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-dd63561a-25"
})(_templateObject25());
var ReviewText = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-dd63561a-26"
})(_templateObject26());
var ReviewInfo = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-27"
})(_templateObject27());
var ReviewContent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-28"
})(_templateObject28());
var FeedbackControls = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-29"
})(_templateObject29());
var RecommendBtnWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd63561a-30"
})(_templateObject30());
var RecommendBtn = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-dd63561a-31"
})(_templateObject31());
var RecommendBtnIcon = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-dd63561a-32"
})(_templateObject32(), (_PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_3___default()), function(props) {
    return props.$isActive && "\n		background: transparent url(".concat((_PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_3___default()), ") -22px -18px / 93px 40px;\n	");
});
var LikeCount = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-dd63561a-33"
})(_templateObject33());
var ListLink = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-dd63561a-34"
})(_templateObject34());
var BestTag = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-dd63561a-35"
})(_templateObject35());



/***/ }),

/***/ 67341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ WriteRequest; },
/* harmony export */   "Ar": function() { return /* binding */ SubTitleWrap; },
/* harmony export */   "CF": function() { return /* binding */ LoadMoreBtn; },
/* harmony export */   "Ck": function() { return /* binding */ ReviewGallery; },
/* harmony export */   "ER": function() { return /* binding */ Summary; },
/* harmony export */   "Ej": function() { return /* binding */ Date; },
/* harmony export */   "FR": function() { return /* binding */ RecommendBtnWrap; },
/* harmony export */   "Hl": function() { return /* binding */ HighlightItem; },
/* harmony export */   "Lm": function() { return /* binding */ GalleryItem; },
/* harmony export */   "Nt": function() { return /* binding */ ReviewGalleryItem; },
/* harmony export */   "Rx": function() { return /* binding */ TravelReviewList; },
/* harmony export */   "Vp": function() { return /* binding */ RecommendBtn; },
/* harmony export */   "Xn": function() { return /* binding */ Tag; },
/* harmony export */   "Yg": function() { return /* binding */ ReviewerProfile; },
/* harmony export */   "aw": function() { return /* binding */ RecommendBtnIcon; },
/* harmony export */   "cB": function() { return /* binding */ TripLabel; },
/* harmony export */   "cL": function() { return /* binding */ TravelReviewListItem; },
/* harmony export */   "eE": function() { return /* binding */ ToolTip; },
/* harmony export */   "gG": function() { return /* binding */ Percent; },
/* harmony export */   "gI": function() { return /* binding */ CategoryTitle; },
/* harmony export */   "hc": function() { return /* binding */ ReviewFilter; },
/* harmony export */   "i1": function() { return /* binding */ TravelReviewWrap; },
/* harmony export */   "iG": function() { return /* binding */ Rating; },
/* harmony export */   "iH": function() { return /* binding */ ToolTipBtn; },
/* harmony export */   "kO": function() { return /* binding */ TravelReviewListTitle; },
/* harmony export */   "lW": function() { return /* binding */ ScoreWrap; },
/* harmony export */   "lb": function() { return /* binding */ ReviewText; },
/* harmony export */   "lv": function() { return /* binding */ ReviewTopBar; },
/* harmony export */   "n8": function() { return /* binding */ CustomerReview; },
/* harmony export */   "nM": function() { return /* binding */ FeedbackControls; },
/* harmony export */   "nS": function() { return /* binding */ ReviewListItem; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; },
/* harmony export */   "oU": function() { return /* binding */ LikeCount; },
/* harmony export */   "og": function() { return /* binding */ ProfileDetails; },
/* harmony export */   "ot": function() { return /* binding */ CheckboxWrap; },
/* harmony export */   "p$": function() { return /* binding */ SubHeadingWrap; },
/* harmony export */   "q": function() { return /* binding */ TravelReviewListInfo; },
/* harmony export */   "ri": function() { return /* binding */ Gallery; },
/* harmony export */   "uQ": function() { return /* binding */ ReportBtn; },
/* harmony export */   "vA": function() { return /* binding */ SelectWrap; },
/* harmony export */   "vx": function() { return /* binding */ UserName; },
/* harmony export */   "xK": function() { return /* binding */ Highlights; },
/* harmony export */   "xu": function() { return /* binding */ Box; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93391);
/* harmony import */ var _PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99653);
/* harmony import */ var _PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14358);
/* harmony import */ var _PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81499);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin-top: 60px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: grid;\n	height: 60px;\n	border-bottom: 1px solid var(--line-color);\n	white-space: nowrap;\n	align-items: center;\n	grid-template-columns: auto 90px 76px;\n	grid-gap: 40px;\n	cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: inline-block;\n	text-align: right;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	",
        ';\n	display: inline-block;\n	max-width: 100%;\n	font-size: var(--default-size);\n	font-family: "pr-font-medium";\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	margin-top: 40px;\n	margin-bottom: 20px;\n	font-family: "pr-font-medium";\n	font-size: var(--medium-size);\n	color: var(--emp-color);\n	line-height: 1;\n\n	span {\n		font-family: "pr-font-bold";\n	}\n\n	',
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding-top: 40px;\n	text-align: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding: 54px 40px;\n	border: 1px solid var(--line-color);\n	border-top: none;\n	box-sizing: border-box;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	position: relative;\n	padding-left: 40px;\n	font-size: 32px;\n	color: #999;\n	line-height: 1;\n\n	span {\n		font-family: "pr-font-bold";\n		font-size: 40px;\n		color: var(--emp-color);\n	}\n\n	em {\n		font-family: "pr-font-bold";\n	}\n\n	&:before {\n		position: absolute;\n		top: 2px;\n		left: 0;\n		width: 30px;\n		height: 30px;\n		background: url(',
        ') -310px 0px / 400px 400px no-repeat;\n		content: "";\n	}\n'
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	margin-top: -6px;\n	font-family: "pr-font-medium";\n	font-size: 18px;\n	color: var(--emp-color);\n	line-height: 1;\n\n	em {\n		color: var(--blue-color);\n	}\n'
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	align-items: center;\n	height: 28px;\n	padding: 0 20px;\n	border-radius: 4px;\n	background-color: #fff4d5;\n	font-size: var(--basic-size);\n	color: var(--emp-color);\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding: 20px 40px;\n	margin-top: 18px;\n	border-radius: 12px;\n	background-color: var(--disabled-color);\n\n	em {\n		display: block;\n		margin-bottom: 8px;\n		font-size: 16px;\n		color: var(--emp-color);\n		line-height: 1;\n	}\n\n	p {\n		margin-bottom: 8px;\n	}\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	display: flex;\n	gap: 4px;\n	flex-wrap: wrap;\n\n	li {\n		font-size: var(--basic-size);\n		color: var(--blue-color);\n		line-height: 1;\n\n		:before {\n			display: inline-block;\n			content: "#";\n		}\n	}\n'
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-wrap: wrap;\n	gap: 10px;\n	margin-top: 20px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	display: flex;\n	align-items: center;\n	height: 28px;\n	padding: 0 20px;\n	background-color: var(--disabled-color);\n	border-radius: 4px;\n	font-size: var(--basic-size);\n	box-sizing: border-box;\n\n	span {\n		margin-left: 30px;\n		font-family: "pr-font-bold";\n		color: var(--emp-color);\n	}\n'
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin-top: 40px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n	display: inline-flex;\n	align-items: center;\n\n	",
        " {\n		margin: 0;\n	}\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	padding: 4px 15px;\n	margin-left: 10px;\n	border-radius: 11px;\n	background-color: #e6f2fb;\n	font-size: var(--basic-size);\n	color: var(--blue-color);\n	line-height: 1;\n\n	em {\n		font-family: "pr-font-bold";\n	}\n'
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n	width: 18px;\n	height: 18px;\n	margin-left: 5px;\n	background: url(",
        ') 0 -287px / 400px 400px no-repeat;\n	font-family: "pr-font-regular";\n'
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	position: absolute;\n	top: 30px;\n	left: -90px;\n	width: 330px;\n	padding: 20px;\n	border: 1px solid var(--yellow-color);\n	background-color: #fff;\n	box-sizing: border-box;\n	text-align: left;\n\n	p {\n		margin-bottom: 6px;\n		color: var(--emp-color);\n	}\n	li {\n		font-size: var(--basic-size);\n		line-height: 1.72;\n		letter-spacing: -0.01em;\n	}\n\n	&:before {\n		position: absolute;\n		display: block;\n		top: -5px;\n		left: 94px;\n		width: 7px;\n		height: 7px;\n		border-top: 1px solid var(--yellow-color);\n		border-left: 1px solid var(--yellow-color);\n		transform: rotate(45deg);\n		background-color: #fff;\n		content: "";\n	}\n'
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: grid;\n	grid-template-columns: repeat(7, 1fr);\n	grid-gap: 9px;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n\n	a {\n		display: block;\n		height: 122px;\n	}\n	img {\n		width: 100%;\n		height: 100%;\n		object-fit: fill;\n	}\n\n	",
        "\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: grid;\n	grid-template-columns: repeat(10, 1fr);\n	grid-gap: 5px;\n	margin-top: 20px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n\n	a {\n		display: block;\n		height: 86px;\n	}\n\n	img {\n		width: 100%;\n		height: 100%;\n		object-fit: fill;\n	}\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: space-between;\n	height: 60px;\n	padding: 0 20px;\n	margin-top: 40px;\n	border-top: 1px solid var(--emp-color);\n	border-bottom: 1px solid var(--line-color);\n	background-color: var(--disabled-color);\n	box-sizing: border-box;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n	width: 140px;\n	height: 40px;\n\n	ul {\n		top: 39px;\n	}\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: inline-flex;\n	align-items: center;\n	gap: 10px;\n	margin-left: 20px;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding: 40px 0;\n	border-bottom: 1px solid var(--line-color);\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	em {\n		margin-left: 10px;\n		font-size: 16px;\n		font-family: "pr-font-bold";\n		color: var(--emp-color);\n	}\n'
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: grid;\n	grid-template-columns: auto 1fr auto;\n	align-items: center;\n	gap: 20px;\n	line-height: 1;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	gap: 20px;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--emp-color);\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	span:not(:first-child) {\n		position: relative;\n		padding-left: 13px;\n		margin-left: 10px;\n\n		&:before {\n			position: absolute;\n			top: 50%;\n			left: 0;\n			display: inline-block;\n			width: 3px;\n			height: 3px;\n			background-color: var(--line-color);\n			transform: translateY(-50%);\n			content: "";\n		}\n	}\n'
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	font-size: var(--basic-size);\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin: 15px 0 10px;\n	",
        "\n	letter-spacing: 0.015em;\n\n	",
        "\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	justify-content: space-between;\n	margin-top: 17px;\n	line-height: 1;\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n	display: flex;\n	align-items: center;\n	padding-left: 30px;\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	position: relative;\n	display: block;\n	margin-right: 10px;\n	background-color: #fff;\n	font-family: "pr-font-regular";\n	font-size: var(--basic-size);\n'
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: absolute;\n	top: -2px;\n	left: 0;\n	display: inline-block;\n	width: 21px;\n	height: 18px;\n	background: transparent url(",
        ') 0 -18px / 93px 40px;\n	cursor: pointer;\n\n	&:before {\n		display: inline-block;\n		position: absolute;\n		top: -5px;\n		left: -5px;\n		width: 30px;\n		height: 30px;\n		border-radius: 50%;\n		box-shadow: inset 0 0 0 50px var(--blue-color);\n		opacity: 0;\n		transform: scale(0);\n		transition: box-shadow 0.3s 0.2s, opacity 0.3s, transform 0.3s;\n		content: "";\n	}\n\n	',
        "\n\n	@keyframes change {\n		50% {\n			transform: scale(0);\n		}\n		100% {\n			transform: scale(1);\n		}\n	}\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	font-size: var(--basic-size);\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	background-color: transparent;\n	font-size: var(--basic-size);\n	text-decoration: underline;\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin-top: 60px;\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	width: 100%;\n	margin-top: 40px;\n	background-color: #fff;\n	font-family: "pr-font-regular";\n	em {\n		position: relative;\n		display: inline-block;\n		padding-right: 22px;\n		&:after {\n			display: inline-block;\n			position: absolute;\n			top: 3px;\n			right: 2px;\n			width: 7px;\n			height: 7px;\n			border-top: 1px solid var(--default-color);\n			border-left: 1px solid var(--default-color);\n			transform: rotate(225deg);\n			content: "";\n		}\n	}\n'
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}




var SubTitleWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-0"
})(_templateObject());
var TravelReviewListItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-1"
})(_templateObject1());
var TravelReviewListInfo = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-9c69473-2"
})(_templateObject2());
var TravelReviewListTitle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h5.withConfig */ .ZP.h5.withConfig({
    componentId: "sc-9c69473-3"
})(_templateObject3(), (0,_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_3__/* .Ellipsis */ .mH)(1));
var CategoryTitle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-9c69473-4"
})(_templateObject4(), function(props) {
    return props.$line && "\n		margin-bottom: 0;\n		padding-bottom: 20px;\n		border-bottom: 1px solid var(--emp-color);\n	";
});
var WriteRequest = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-9c69473-5"
})(_templateObject5());
var Box = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-6"
})(_templateObject6());
var Rating = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-7"
})(_templateObject7(), (_PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1___default()));
var CustomerReview = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-9c69473-8"
})(_templateObject8());
var TripLabel = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-9c69473-9"
})(_templateObject9());
var Summary = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-10"
})(_templateObject10());
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-9c69473-11"
})(_templateObject11());
var Highlights = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-9c69473-12"
})(_templateObject12());
var HighlightItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-9c69473-13"
})(_templateObject13());
var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-14"
})(_templateObject14());
var SubHeadingWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-15"
})(_templateObject15(), CategoryTitle);
var Percent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-9c69473-16"
})(_templateObject16());
var ToolTipBtn = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-9c69473-17"
})(_templateObject17(), (_PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1___default()));
var ToolTip = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-18"
})(_templateObject18());
var Gallery = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-9c69473-19"
})(_templateObject19());
var GalleryItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-9c69473-20"
})(_templateObject20(), function(props) {
    return props.$isList && '\n		cursor: pointer;\n\n		&:before {\n			position: absolute;\n		    width: 100%;\n			height: 100%;\n			background-color: rgba(0, 0, 0, 0.6);\n			content: "";\n			pointer-events: none;\n		}\n\n		&:after {\n			position: absolute;\n			top: 50%;\n			left: 50%;\n			color: #fff;\n			transform: translate(-50%, -50%);\n			content: "더보기";\n			pointer-events: none;\n		}\n	';
});
var ReviewGallery = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-9c69473-21"
})(_templateObject21());
var ReviewGalleryItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-9c69473-22"
})(_templateObject22());
var ReviewFilter = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-23"
})(_templateObject23());
var SelectWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-24"
})(_templateObject24());
var CheckboxWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-25"
})(_templateObject25());
var ReviewListItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-9c69473-26"
})(_templateObject26());
var ScoreWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-27"
})(_templateObject27());
var ReviewTopBar = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-28"
})(_templateObject28());
var ReviewerProfile = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-29"
})(_templateObject29());
var UserName = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-9c69473-30"
})(_templateObject30());
var ProfileDetails = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-31"
})(_templateObject31());
var Date = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].time.withConfig */ .ZP.time.withConfig({
    componentId: "sc-9c69473-32"
})(_templateObject32());
var ReviewText = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-9c69473-33"
})(_templateObject33(), (0,_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_3__/* .Ellipsis */ .mH)(3), function(props) {
    return props.isShow && "\n		-webkit-line-clamp: initial;\n	";
});
var FeedbackControls = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-34"
})(_templateObject34());
var RecommendBtnWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-35"
})(_templateObject35());
var RecommendBtn = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-9c69473-36"
})(_templateObject36());
var RecommendBtnIcon = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-9c69473-37"
})(_templateObject37(), (_PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_2___default()), function(props) {
    return props.$isActive && "\n		background: transparent url(".concat((_PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_2___default()), ") -22px -18px / 93px 40px;\n		animation: change .5s forwards;\n\n		&:before {\n			box-shadow: inset 0 0 0 0 var(--blue-color);\n			opacity: 1;\n			transform: scale(1);\n		}\n	");
});
var LikeCount = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-9c69473-38"
})(_templateObject38());
var ReportBtn = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-9c69473-39"
})(_templateObject39());
var TravelReviewWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9c69473-40"
})(_templateObject40());
var TravelReviewList = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-9c69473-41"
})(_templateObject41());
var LoadMoreBtn = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-9c69473-42"
})(_templateObject42());



/***/ }),

/***/ 61817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21741);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




var key = "useWishlist";
/** ```
 * 위시리스트 조회
 *  `/customer/wishList?webCustNo={webCustNo}`
 * parameter
 * ```*/ var getPath = function(webCustNo) {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_ESSENTIAL_API_BASEPATH */ .Z.ENV_ESSENTIAL_API_BASEPATH, "/api/customer/wishList?webCustNo=").concat(webCustNo);
};
/** ```
 * 위시리스트 조회
 *   `/customer/wishList?webCustNo={webCustNo}`
 * parameter
 * ```*/ var useWishlist = function(webCustNo, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(webCustNo)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(webCustNo)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity
    }, options));
};
/* harmony default export */ __webpack_exports__["Z"] = (useWishlist);



/***/ }),

/***/ 95134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 공통 코드 조회
 *   `/esntl/common/code/${cmmnGrpCode}`
 * parameter
 *   `cmmnGrpCode` 공통그룹코드
 * ```*/ var key = "useCode";
var getPath = function(cmmnGrpCode) {
    if (!cmmnGrpCode) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/portal/common/code/").concat(cmmnGrpCode);
};
/** ```
 * 공통 코드 조회
 *   `/esntl/common/code/${cmmnGrpCode}`
 * parameter
 *   `cmmnGrpCode` 공통그룹코드
 * ```*/ var usePortalCode = function(cmmnGrpCode, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(cmmnGrpCode)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(cmmnGrpCode)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (usePortalCode);



/***/ }),

/***/ 3889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 이용 약관 조회
 *   `/portal/product/${goodsCd}/review`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var key = "useReview";
var getPath = function(goodsCd) {
    if (!goodsCd) return "";
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/portal/product/").concat(goodsCd, "/review");
};
/** ```
 * 이용 약관 조회
 *   `/portal/product/${goodsCd}/review`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var useReview = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(goodsCd)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReview);



/***/ }),

/***/ 50297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




var key = "useReviewAI";
/** ```
 * 리뷰 AI 조회
 *   `/portal/product/${goodsCd}/review/ai-info`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var getPath = function(goodsCd) {
    if (!goodsCd) return "";
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/portal/product/").concat(goodsCd, "/review/ai-info");
};
/** ```
 * 리뷰 AI 조회
 *   `/portal/product/${goodsCd}/review/ai-info`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var useReviewAI = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(goodsCd)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReviewAI);



/***/ }),

/***/ 81258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oM": function() { return /* binding */ reviewLikeAsync; }
/* harmony export */ });
/* unused harmony exports getPath, key */
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21741);



var key = "useReviewLike";
var getPath = function() {
    return "/bff/portal/reviewLike";
};
/** ```
 * 리뷰 좋아요 BFF
 *   `/bff/portal/reviewLike`
 * parameter
 *   `goodsCd` 상품코드
 *   `reviewId` 리뷰ID
 * ```*/ var reviewLikeAsync = function(params) {
    return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        url: getPath(),
        params: params
    });
};
/** ```
 * 리뷰 좋아요 BFF
 *   `/bff/portal/reviewLike`
 * parameter
 *   `goodsCd` 상품코드
 *   `reviewId` 리뷰ID
 * ```*/ var useReviewLike = function(params, options) {
    return useQuery(_object_spread({
        queryKey: [
            key,
            getPath()
        ],
        queryFn: function() {
            return useConfigureAxios({
                url: getPath(),
                params: params
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useReviewLike)));



/***/ }),

/***/ 26163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87633);



var key = "useReviewLikeRecommender";
/** ```
 * 고객리뷰 추천 조회
 *   `/bff/portal/reviewLikeRecommender`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var getPath = function() {
    return "/bff/portal/reviewLikeRecommender";
};
/** ```
 * 고객리뷰 추천 조회
 *   `/bff/portal/reviewLikeRecommender`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var useReviewLikeRecommender = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath()
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(),
                params: {
                    goodsCd: goodsCd
                }
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReviewLikeRecommender);



/***/ }),

/***/ 37006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sW": function() { return /* binding */ reviewReportAsync; }
/* harmony export */ });
/* unused harmony exports getPath, key */
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21741);



var key = "useReviewReport";
var getPath = function() {
    return "/bff/portal/reviewReport";
};
/** ```
 * 리뷰 신고하기 BFF
 *   `/bff/portal/reviewReport`
 * parameter
 *   `reportId` 리뷰ID
 *   `reportType` 신고하기 타입
 *   `reportCode` 신고하기 코드
 *   `reportContents` 신고하기 내용
 * ```*/ var reviewReportAsync = function(data) {
    return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        url: getPath(),
        method: "POST",
        data: data
    });
};
/** ```
 * 리뷰 신고하기 BFF
 *   `/bff/portal/reviewReport`
 * parameter
 *   `reportId` 리뷰ID
 *   `reportType` 신고하기 타입
 *   `reportCode` 신고하기 코드
 *   `reportContents` 신고하기 내용
 * ```*/ var useReviewReport = function(params, options) {
    return useQuery(_object_spread({
        queryKey: [
            key,
            getPath()
        ],
        queryFn: function() {
            return useConfigureAxios({
                url: getPath(),
                method: "POST",
                params: params,
                data: params
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useReviewReport)));



/***/ }),

/***/ 56088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 이용 약관 조회
 *   `/portal/product/${goodsCd}/review/summary`
 * parameter
 *   `policyCodeIdHi` 공통코드 상위 ID
 * ```*/ var key = "useReviewSummary";
var getPath = function(goodsCd) {
    if (!goodsCd) return "";
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/portal/product/").concat(goodsCd, "/review/summary");
};
/** ```
 * 이용 약관 조회
 *   `/portal/product/${goodsCd}/review/summary`
 * parameter
 *   `policyCodeIdHi` 공통코드 상위 ID
 * ```*/ var useReviewSummary = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(goodsCd)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReviewSummary);



/***/ }),

/***/ 93381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ri": function() { return /* binding */ useCouponByUser; }
/* harmony export */ });
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21741);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 쿠폰 리스트 조회
 *   `/prdt/api/coupon/by-event/${evCd}/${webCustNo}`
 * parameter
 *   `evCd` 예약자 일련번호
 * ```*/ var key = "useCouponByEvent";
var getPath = function(evCd, webCustNo) {
    if (!evCd) return null;
    if (webCustNo) return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PRODUCT_API_BASEPATH */ .Z.ENV_PRODUCT_API_BASEPATH, "/api/coupon/by-event/").concat(evCd, "/").concat(webCustNo);
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PRODUCT_API_BASEPATH */ .Z.ENV_PRODUCT_API_BASEPATH, "/api/coupon/by-event/").concat(evCd);
};
/** ```
 * 쿠폰 리스트 조회 by event
 *   `/prdt/api/coupon/by-event/${evCd}`
 * parameter
 *   `evCd` 예약자 일련번호
 * ```*/ var useCouponByEvent = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        }
    }, options));
};
/** ```
 * 쿠폰 리스트 조회 by user
 *   `/prdt/api/coupon/by-event/${evCd}/${webCustNo}`
 * parameter
 *   `evCd` 예약자 일련번호
 *   `webCustNo` 회원 일련번호
 * ```*/ var useCouponByUser = function(evCd, webCustNo, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd, webCustNo)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd, webCustNo)
            }).then(function(r) {
                return r.data;
            });
        }
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useCouponByEvent);



/***/ }),

/***/ 46894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21741);




var getPath = function() {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_CHORUS_API_BASEPATH */ .Z.ENV_CHORUS_API_BASEPATH, "/cpon/issueCoupon");
};
var couponDownAsync = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(data) {
        var reuslt, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(getPath(), (_tmp.method = "POST", _tmp.data = data, _tmp))
                    ];
                case 1:
                    reuslt = _state.sent();
                    return [
                        2,
                        reuslt
                    ];
            }
        });
    });
    return function couponDownAsync(data) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (couponDownAsync);


/***/ }),

/***/ 64380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 리뷰 사진 조회
 *   `/api/bff/vimeo/videos/${vimeoId}`
 * parameter
 *   `vimeoId
 * ```*/ var key = "useReviewSummary";
var getPath = function(vimeoId) {
    if (!vimeoId) return "";
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_SUPPORT_URL */ .Z.ENV_SUPPORT_URL, "/api/bff/vimeo/videos/").concat(vimeoId);
};
/** ```
 * 리뷰 사진 조회
 *   `/api/bff/vimeo/videos/${vimeoId}`
 * parameter
 *   `vimeoId
 * ```*/ var useReviewPictures = function(vimeoId, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(vimeoId)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(vimeoId)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: 1000 * 60 * 30,
        staleTime: 1000 * 60 * 30,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReviewPictures);



/***/ }),

/***/ 79972:
/***/ (function(module) {

module.exports = "data:image/png;base64,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"

/***/ })

}]);